const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookshelf = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 435.69 420.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M344.8.14l2,.23a16.74,16.74,0,0,1,4.33,5.55A20.39,20.39,0,0,1,355,2.71c2.59-.62,5.29-.29,7.94-.23-.55,4.59-3,9.85-8.11,10.52,2.68-2.55,5.41-5.35,6-9.16a34,34,0,0,0-5.44.36c-2,.76-2.66,3-3.62,4.64,1.48-.61,2.94-1.26,4.4-1.94-1.33,1.82-2.57,3.71-3.75,5.64a12.14,12.14,0,0,0-4.5,3.17c-1.36-1.36-2.71-2.71-4.12-4A21,21,0,0,1,344.8.14Z",
    style: {
      fill: "#2d3129",
      stroke: "#2d3129",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,2.08c2,.31,4.29-.06,5.92,1.34,3.45,2.13,4,6.5,6.67,9.31L344,13.87c-.46,1.88-.89,3.76-1.31,5.65-2.46,0-4.92-.06-7.38-.18-2.45-1.46-4.83-3.72-5-6.73,1.58-.42,3.17-.85,4.76-1.26C331.88,9.29,331.47,5.5,331.63,2.08Z",
    style: {
      fill: "#304130",
      stroke: "#304130",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.32,3c2.27-.92,3.82,1.49,4.59,3.27.85,2.41-.69,4.7-1.75,6.75C344.06,11.29,344.35,6.62,345.32,3Z",
    style: {
      fill: "#2f6c3d",
      stroke: "#2f6c3d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.36,3.93a7.54,7.54,0,0,1,7.15,6.53c-2.16-1.06-3.74-2.88-5.4-4.55.86,1.75,1.69,3.52,2.45,5.32C334.81,9.83,332.63,7.2,333.36,3.93Z",
    style: {
      fill: "#467051",
      stroke: "#467051",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.42,4.2a34,34,0,0,1,5.44-.36c-.63,3.81-3.36,6.61-6,9.16l-2.37-.46c1.18-1.93,2.42-3.82,3.75-5.64-1.46.68-2.92,1.33-4.4,1.94C352.76,7.16,353.43,5,355.42,4.2Z",
    style: {
      fill: "#3a7652",
      stroke: "#3a7652",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,14c3.28-.76,7.61-1.91,9.42,1.93-1.88-.3-3.77-.61-5.66-.84a40.76,40.76,0,0,0,6.3,2.88C338.19,20.27,334.22,17.09,332,14Z",
    style: {
      fill: "#457b52",
      stroke: "#457b52",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,13.87l.34-1.2c.31,2,.56,3.94.72,5.92h1.39a7.32,7.32,0,0,1,3-3.9l0,1.16c0,.52,0,1.56-.05,2.07l3.9,1.88A11.35,11.35,0,0,0,357.17,16c-1.6-.62-3.2-1.24-4.81-1.83l-1.07-.41c2.56-.6,5.11,0,7.57.71-.07.45-.22,1.33-.3,1.77-.6,1-1.19,2-1.75,3l4.92.26c.08,4.49.08,9,.07,13.47.24,4.29-2.58,7.89-5.4,10.8,16.53-.08,33.05,0,49.58,0,0,3.52.14,7.06,0,10.58l-1.45.3c-.08-.51-.25-1.53-.33-2-.19-2.34-.23-4.7-.31-7-115.56.31-231.13,0-346.69.12-5.73,0-11.47,0-17.21-.13,9.13-2.74,18.92.77,28.09-1.89,3.68-.53,7.4-.27,11.1-.29,19.29.19,38.59-.16,57.88.17l5.68.15c64.2.1,128.41,0,192.62.06a26.85,26.85,0,0,1-5.55-7.85c-.24-5.5-.15-11-.1-16.51,1.87-.05,3.74-.1,5.62,0,2.46.12,4.92.16,7.38.18C343.09,17.63,343.52,15.75,344,13.87Z",
    style: {
      fill: "#481e18",
      stroke: "#481e18",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,14.5l2.81-.38c1.61.59,3.21,1.21,4.81,1.83a11.35,11.35,0,0,1-3.84,3.86l-3.9-1.88c0-.51,0-1.55.05-2.07Z",
    style: {
      fill: "#446948",
      stroke: "#446948",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.49,21.15c4-.06,8-.07,12.05,0,0,.33-.08,1-.11,1.3-.31,5.16-1.27,10.58.6,15.55,1,2.12,2.47,4.78,5.11,4.85,1.47-.06,2.93-.16,4.4-.31l.07,1.29c-5-.22-10.09.21-15.06-.5-4-2.36-7.38-6.61-7.06-11.45C331.45,28.32,331.54,24.73,331.49,21.15Z",
    style: {
      fill: "#d5815d",
      stroke: "#d5815d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.54,21.18c5.41.17,10.83.07,16.25,0-.75,6.19,1.81,13.39-2.58,18.64-1,1.13-2,2.63-3.67,2.73-1.47.15-2.93.25-4.4.31,2.66-.68,5.47-1.71,7-4.13,3.11-3.9,3-9.22,2.4-13.91,0-1.72-1.83-2.55-3.32-2.45a106,106,0,0,0-11.82.09C343.46,22.16,343.51,21.51,343.54,21.18Z",
    style: {
      fill: "#f3c3ab",
      stroke: "#f3c3ab",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.43,22.48a106,106,0,0,1,11.82-.09c1.49-.1,3.32.73,3.32,2.45.58,4.69.71,10-2.4,13.91-1.56,2.42-4.37,3.45-7,4.13C346.5,42.81,345,40.15,344,38,342.16,33.06,343.12,27.64,343.43,22.48Z",
    style: {
      fill: "#fb986e",
      stroke: "#fb986e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,30.31a18,18,0,0,1,4.32-.63l72.68,0c.1,3.45-3.49,5.83-2.83,9.39a24.49,24.49,0,0,0,2.68,4.58L137,43.52c-.77-1.57-1.52-3.15-2.15-4.78l-.32-.82.11-1.11.08-.66c.1-.68.29-2,.39-2.71-22.47.13-44.94-.13-67.41.1-.09,1.88-.21,3.75-.17,5.63.09,1.49.29,3,.49,4.47-9.17,2.66-19-.85-28.09,1.89l-.33.06c-.5-.5-1.48-1.52-2-2,9,.33,18.07-.13,27.1.29C63.1,39.43,62.82,34.22,65.85,30.31Z",
    style: {
      fill: "#642635",
      stroke: "#642635",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72,33.54c22.47-.23,44.94,0,67.41-.1-.1.68-.29,2-.39,2.71-21.57.26-43.16-.26-64.71.26l-.47.58-.72.94-.74.88-.55.36C67.51,37.29,67.63,35.42,67.72,33.54Z",
    style: {
      fill: "#e9d6d7",
      stroke: "#e9d6d7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,36.41c21.55-.52,43.14,0,64.71-.26l-.08.66c-21.7,0-43.41-.14-65.1.18Z",
    style: {
      fill: "#f9f6f7",
      stroke: "#f9f6f7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.56,37c21.69-.32,43.4-.13,65.1-.18l-.11,1.11c-21.9-.19-43.81,0-65.71,0Z",
    style: {
      fill: "#bdb9ba",
      stroke: "#bdb9ba",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.84,37.93c21.9,0,43.81-.2,65.71,0l.32.82c-6.56.39-13.13.36-19.7.19-15.69,0-31.38.09-47.07-.12Z",
    style: {
      fill: "#f4ebf0",
      stroke: "#f4ebf0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.55,39.17l.55-.36c15.69.21,31.38.14,47.07.12,6.57.17,13.14.2,19.7-.19.63,1.63,1.38,3.21,2.15,4.78-19.29-.33-38.59,0-57.88-.17-3.7,0-7.42-.24-11.1.29C67.84,42.15,67.64,40.66,67.55,39.17Z",
    style: {
      fill: "#d8b8bc",
      stroke: "#d8b8bc",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.57,40.64c2.07-1,4.45-.7,6.68-.75,19.83-.37,39.67-.07,59.5-.07-1.73,1.75-4.38,1-6.56,1.21C108.32,40.56,88.43,41.24,68.57,40.64Z",
    style: {
      fill: "#efe7e8",
      stroke: "#efe7e8",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.55,55.63c-2-3.67-.75-8.08-.91-12.07.5.51,1.48,1.53,2,2a59.24,59.24,0,0,0,.21,7l.72,2c.41,71.47-.07,143,.22,214.44L40,270.64l-1.41.84C38.68,199.53,38.79,127.58,38.55,55.63Z",
    style: {
      fill: "#4b1e21",
      stroke: "#4b1e21",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.62,45.59l.33-.06c5.74.14,11.48.13,17.21.13,115.56-.09,231.13.19,346.69-.12.08,2.34.12,4.7.31,7Q222,52.47,39.83,52.64A59.24,59.24,0,0,1,39.62,45.59Z",
    style: {
      fill: "#f89871",
      stroke: "#f89871",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.83,52.64q182.16-.33,364.33-.06c.08.51.25,1.53.33,2l.16.9-2.2-.57a60.73,60.73,0,0,0-10.09-.23c-.18,54,0,108.08-.11,162.12.16,7-.42,14,0,21,.37,13.31-.39,26.63-.15,39.95.4,9.21-.21,18.41-.1,27.62l-2,0c-.4-13.84,0-27.68-.17-41.52.06-12.18-.18-24.36.21-36.54,0-.57,0-1.72-.05-2.3-.07-2.75-.14-5.5-.26-8.25.14-22.06.05-44.12.07-66.17-1.59.59-3.3,1.23-3.49,3.18a18,18,0,0,0-6.51-2.09c-12.48-1.44-25.11.34-37.63-.84-17.67,0-35.37-.12-53-.08-24.31.65-48.63-.38-72.94.12-16.65-.38-33.31,0-50-.22a14,14,0,0,0-6.76,1.35c-8.39.82-16.83.1-25.24.41-5.7.33-11.3-1.11-17-1-17.58.22-35.17-.28-52.74.27a11.12,11.12,0,0,0-8.59-1.17l-2.48.48c0,21.26,0,42.53,0,63.8l6,.19c-.06.58-.17,1.73-.23,2.31-2,.06-3.9.09-5.84.12-.06,2.56-.14,5.13-.15,7.71,2.55,1.64,5.71.93,8.57,1l-.24.86c-2.68.11-5.35.09-8,.09-.16,23.23,0,46.46-.1,69.69,0,6.66.19,13.33-.29,20L51.07,318c-.18-87.79.1-175.59-.1-263.39-3.48,0-6.95.08-10.42,0Z",
    style: {
      fill: "#6a2d26",
      stroke: "#6a2d26",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.55,54.65c3.47.08,6.94,0,10.42,0,.2,87.8-.08,175.6.1,263.39-.18,5.39-.1,10.79-.34,16.18,0-9.15-1.55-18.16-3.23-27.12q-3.42.18-6.82.44c0-7.87-.11-15.74.18-23.6,4-4.18,3-10.75,3.78-16.09-1.3.38-2.6.76-3.87,1.24C40.48,197.61,41,126.12,40.55,54.65Z",
    style: {
      fill: "#f8976f",
      stroke: "#f8976f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.42,55.1c8.58-.57,17.18.06,25.76-.06q153.14,0,306.27,0l-.61.54c-3.12,2.54-6.07,6.35-10.53,6-101,.23-202.08-.14-303.12.11a40.51,40.51,0,0,1-9.71-.8A34.66,34.66,0,0,0,55.42,55.1Z",
    style: {
      fill: "#834138",
      stroke: "#834138",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.36,54.72a60.73,60.73,0,0,1,10.09.23q.06,125.34-.05,250.68c-3.47,0-6.93-.09-10.4-.19-.11-9.21.5-18.41.1-27.62-.24-13.32.52-26.64.15-39.95-.42-7,.16-14,0-21C392.32,162.8,392.18,108.76,392.36,54.72Z",
    style: {
      fill: "#f9966e",
      stroke: "#f9966e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.45,55l2.2.57c-.3,55.79-.06,111.57-.14,167.36.08,27.74-.15,55.48.12,83.22-2.09.51-4.16,1.07-6.24,1.62l-.15,0c-9.64-.52-19.28-.05-28.92-.25l.05-1.86c5.2,0,10.4,0,15.6-.1l1.95-.06c1,0,2.08-.06,3.12-.07l2,0c3.47.1,6.93.16,10.4.19Q402.66,180.29,402.45,55Z",
    style: {
      fill: "#4b1e21",
      stroke: "#4b1e21",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31,61.6c4.46.35,7.41-3.46,10.53-6l2.22,1.23a56.91,56.91,0,0,0-8.44,7.45l-.52,0a17.31,17.31,0,0,0-4.88-.85q-153.53,0-307.06,0c-1,0-1.89.06-2.83.15l-1.28,1c-1.72.88-3.46,1.7-5.21,2.5.06-.45.19-1.35.25-1.81l3.12-.81c0-.56,0-1.69,0-2.25v-1.6l1.3.28a40.51,40.51,0,0,0,9.71.8C174.23,61.46,275.27,61.83,376.31,61.6Z",
    style: {
      fill: "#4e2020",
      stroke: "#4e2020",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,56.83l.82-.63c-.09,28.69.08,57.38-.1,86.06h0c-1.07-1.84-3.07-1.7-4.87-1.76v-.11c2.17-.5,1.55-2.91,1.8-4.48-.11-23.72.06-47.45-.09-71.17-2-.15-4-.32-6-.46A56.91,56.91,0,0,1,389.06,56.83Z",
    style: {
      fill: "#854744",
      stroke: "#854744",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.47,56.75a72.92,72.92,0,0,0,8.72,5.48c0,.56,0,1.69,0,2.25l-3.12.81c-.06.46-.19,1.36-.25,1.81-.38,19.26-.07,38.53-.1,57.79,0,4.86-.36,9.74.25,14.57l1.58.69.77.35.24,2H61c-1.25-3.19-4.93-1.72-7.47-1.94C53.36,112.61,53.52,84.68,53.47,56.75Z",
    style: {
      fill: "#84433b",
      stroke: "#84433b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.33,63.55c.94-.09,1.88-.14,2.83-.15q153.52,0,307.06,0a17.31,17.31,0,0,1,4.88.85c-4.46.46-8.94.18-13.41.33l-1,.34c-.13.82-.39,2.47-.51,3.29-5.84.27-11.72-.4-17.51.3a19.75,19.75,0,0,0-3.18,3.65c-20.6.66-41.22.29-61.82.28-.1,1.27-.2,2.54-.29,3.81l-5,.11a48.68,48.68,0,0,0-.52-9.35c-5.05-.84-10.23-.31-15.32-.17l0,5.8h-4.85c0-2.43,0-4.85-.05-7.28a133.43,133.43,0,0,0-14,0c0,2.39-.08,4.79-.08,7.18l-5.08.72c-.22-2.9-.46-5.8-.89-8.68-4.44.11-8.91-.3-13.3.52-5.28.9-10.65.15-16,.51-7.07.23-14.14-.18-21.22-.22.18,1.26.39,2.51.62,3.77q-2.72.1-5.43.15l-1.13-1.82c-6.95-1.46-13.95.64-20.93.35-13.35-.12-26.69,0-40-.07a14.56,14.56,0,0,0-8.19,1.79q-2.34-2.56-4.64-5.17c-7.76,0-15.53-.2-23.28.15-6.36.33-12.74,0-19.1.07Z",
    style: {
      fill: "#e6d9d9",
      stroke: "#e6d9d9",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.05,64.6c6.36,0,12.74.26,19.1-.07l.18.69c-.42.49-1.25,1.48-1.66,2-7,0-14-.67-21,0-.1,24.32.14,48.65-.13,73L59,139.46c-.61-4.83-.22-9.71-.25-14.57,0-19.26-.28-38.53.1-57.79C60.59,66.3,62.33,65.48,64.05,64.6Z",
    style: {
      fill: "#3d2636",
      stroke: "#3d2636",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.15,64.53c7.75-.35,15.52-.15,23.28-.15q2.29,2.61,4.64,5.17a14.56,14.56,0,0,1,8.19-1.79c13.35,0,26.69-.05,40,.07,0,.68,0,2-.05,2.71-13,.16-26,.08-39,0a42,42,0,0,0-6.43.55c0,2.41,0,4.82,0,7.23a21.68,21.68,0,0,0-6.07,2.72c-.36,19.87-.09,39.76-.2,59.63l-2,.11-.55-.25c.82-17.53.3-35.1.45-52.65-.19-7.18.43-14.39-.42-21.54-7.11,0-14.21,0-21.31.06l-.36-1.23Z",
    style: {
      fill: "#512331",
      stroke: "#512331",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.17,65.38c7.08,0,14.15.45,21.22.22l-1.68,2.26c-2.6,0-5.21,0-7.81,0l-1.11-1.58c-3.15-.13-6.39-.61-9.45.37.1.22.32.67.43.89.86,2.35.6,4.88.62,7.33-.28,21.84.31,43.69-.28,65.51l-.22,0c-.58-1.22-.78-2.56-1.24-3.81l0-.15a29.46,29.46,0,0,0,.94-6.45c-.24-14.69,0-29.38,0-44.07a19.36,19.36,0,0,0-1-5.48l0-.14a19.82,19.82,0,0,0,.22-11.14C186.56,67.89,186.35,66.64,186.17,65.38Z",
    style: {
      fill: "#553c40",
      stroke: "#553c40",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,65.09c4.39-.82,8.86-.41,13.3-.52l-1.06,2.08c-3.63-.07-7.26-.09-10.89-.15-.24,24.69-.08,49.39-.12,74.09l-1.84.1c-.35-24.35-.09-48.71-.1-73.06l-13.93-.09c-.14,24.34-.08,48.69-.07,73,4.7,0,9.4-.07,14.1.12l-1,1.75c-12.17.13-24.34,0-36.51.05l.35-1.26c.41-1.54.7-3.1,1.06-4.65.46,1.25.66,2.59,1.24,3.81l.22,0c2.58.21,5.18.19,7.78.2.05-24.32,0-48.64,0-73-2.71,0-5.43,0-8.15-.07-.11-.22-.33-.67-.43-.89,3.06-1,6.3-.5,9.45-.37l1.11,1.58c-.08,24.21,0,48.43-.1,72.64q3.9,0,7.82.06c.14-24.24,0-48.49.09-72.73l1.68-2.26C212.7,65.24,218.07,66,223.35,65.09Z",
    style: {
      fill: "#431d26",
      stroke: "#431d26",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,64.57c.43,2.88.67,5.78.89,8.68l5.08-.72c0-2.39,0-4.79.08-7.18a133.43,133.43,0,0,1,14,0c0,2.43,0,4.85.05,7.28h4.85l0-5.8,1.85,1.68q0,36,0,72.05,6,0,12,0h1.93c1.55,0,3.11,0,4.67,0l2.62-.09c5.69-.15,11.39-.12,17.08,0l3.17.12c6.27.19,12.54.11,18.82.08l2.79,0c6.73,0,13.46,0,20.19,0q0-33.13,0-66.27a25.35,25.35,0,0,0-2.18-2.1,19.75,19.75,0,0,1,3.18-3.65c5.79-.7,11.67,0,17.51-.3.12-.82.38-2.47.51-3.29l1-.34c-.43,1.87-.88,3.74-1.24,5.64-5.51-.14-11-.07-16.52-.08-.24,23.49,0,47-.13,70.46l-.48,1.9c-42.19,0-84.39,0-126.57-.07l1-1.75,1.84-.1c3.5-.06,7,0,10.52,0,.73-24.63-.17-49.3.49-73.92Z",
    style: {
      fill: "#4b1e21",
      stroke: "#4b1e21",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.69,64.59c4.47-.15,8.95.13,13.41-.33l.52,0c2,.14,4,.31,6,.46.15,23.72,0,47.45.09,71.17-.25,1.57.37,4-1.8,4.48-.41-5.48-.26-11-.24-16.46.12-17.69-.1-35.38.12-53.07-.22-1.32.36-3-.59-4.09-5.62-.49-11.26.06-16.88-.06-.43,11.38.27,22.77-.16,34.15.13,13.25-.42,26.5.14,39.73,5.87.07,11.75,0,17.62-.09,1.8.06,3.8-.08,4.87,1.76-13.81.52-27.64.22-41.45.25l.48-1.9c5.41-.18,10.81,0,16.22-.06q.12-31.32.06-62.63a58.08,58.08,0,0,1,.37-7.69C365.81,68.33,366.26,66.46,366.69,64.59Z",
    style: {
      fill: "#6b1d1a",
      stroke: "#6b1d1a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.67,67.2c.41-.5,1.24-1.49,1.66-2l.36,1.23c.41,24.67,0,49.37.11,74.05,7.06.22,14.11-.05,21.17.08l.55.25-.11,1.62c-14.61,0-29.22,0-43.83,0l-.24-2c6.75.19,13.5.12,20.24,0C81.61,116.05,81.47,91.62,81.67,67.2Z",
    style: {
      fill: "#401624",
      stroke: "#401624",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.69,66.45c7.1-.1,14.2-.08,21.31-.06.85,7.15.23,14.36.42,21.54-.15,17.55.37,35.12-.45,52.65-7.06-.13-14.11.14-21.17-.08C83.7,115.82,84.1,91.12,83.69,66.45Z",
    style: {
      fill: "#ed5f5d",
      stroke: "#ed5f5d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,67.17c7-.64,14,0,21,0-.2,24.42-.06,48.85-.09,73.28-6.74.14-13.49.21-20.24,0l-.77-.35C60.84,115.82,60.6,91.49,60.7,67.17Z",
    style: {
      fill: "#98b3d0",
      stroke: "#98b3d0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3,67.83c7,.29,14-1.81,20.93-.35l1.13,1.82q2.71,0,5.43-.15a19.82,19.82,0,0,1-.22,11.14l0-.84c-.24-2.77-.32-5.55-.41-8.33l-5.37.28-1.8-1.83-.83-.83c-3.13-.23-6.26-.24-9.4-.31-.16,3.83-.19,7.68-.13,11.52l-2.33,1.48c-3.27-.25-6.56-.31-9.84-.27-.77,7.23.18,14.49-.11,21.74,0,12.61-.88,25.29.35,37.86l.52,1.74c-1.75,0-3.49,0-5.24,0l.61-1.88,2-.13c-.21-17.72.09-35.43-.09-53.14,0-.49,0-1.46,0-1.94q0-2.07.09-4.14l2.73-2.79a19.85,19.85,0,0,0,9.31-1.39c-.35-2.16.87-5.41-1.91-6.29a24.57,24.57,0,0,0-5.42-.23C159.26,69.86,159.29,68.51,159.3,67.83Z",
    style: {
      fill: "#4b1e21",
      stroke: "#4b1e21",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.58,140.59c0-24.7-.12-49.4.12-74.09,3.63.06,7.26.08,10.89.15-.66,24.62.24,49.29-.49,73.92C231.59,140.59,228.08,140.53,224.58,140.59Z",
    style: {
      fill: "#dbdbda",
      stroke: "#dbdbda",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.57,67.23c3.39-.11,6.78-.11,10.17.11.09,24.41.2,48.82-.05,73.22-3.33,0-6.65,0-10,.06-.15-1.92-.27-3.84-.27-5.77C244.58,112.31,244.51,89.77,244.57,67.23Z",
    style: {
      fill: "#eb605f",
      stroke: "#eb605f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,66.85c5.09-.14,10.27-.67,15.32.17a48.68,48.68,0,0,1,.52,9.35l5-.11c.09-1.27.19-2.54.29-3.81,20.6,0,41.22.38,61.82-.28a25.35,25.35,0,0,1,2.18,2.1c-6.72.3-13.44.12-20.16.14,0,.37,0,1.11,0,1.48l-2.17-.64a58.22,58.22,0,0,0-19-.27,77,77,0,0,0-.32,11q0,27.28-.11,54.58l-3.17-.12c0-21.69-.06-43.38,0-65.07-5.69.07-11.39,0-17.09,0-.08,21.7.14,43.39,0,65.09l-2.62.09c.19-20.8-.24-41.59.25-62.38h-4.87c0,20.81,0,41.62-.05,62.42h-1.93c-.11-24,.08-48,0-72-4,0-8,.17-12,0Z",
    style: {
      fill: "#2e2037",
      stroke: "#2e2037",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.3,66.71c5.62.12,11.26-.43,16.88.06.95,1.06.37,2.77.59,4.09-.22,17.69,0,35.38-.12,53.07,0,5.48-.17,11,.24,16.46v.11c-5.87.05-11.75.16-17.62.09-.56-13.23,0-26.48-.14-39.73C367.57,89.48,366.87,78.09,367.3,66.71Z",
    style: {
      fill: "#c9616a",
      stroke: "#c9616a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.77,67.57c2.72.06,5.44,0,8.15.07,0,24.33,0,48.65,0,73-2.6,0-5.2,0-7.78-.2.59-21.82,0-43.67.28-65.51C188.37,72.45,188.63,69.92,187.77,67.57Z",
    style: {
      fill: "#fef4ed",
      stroke: "#fef4ed",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9,67.89c2.6,0,5.21,0,7.81,0-.05,24.24,0,48.49-.09,72.73q-3.92,0-7.82-.06C197.92,116.32,197.82,92.1,197.9,67.89Z",
    style: {
      fill: "#fdf2ea",
      stroke: "#fdf2ea",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.64,140.57c0-24.34-.07-48.69.07-73l13.93.09c0,24.35-.25,48.71.1,73.06C218,140.5,213.34,140.6,208.64,140.57Z",
    style: {
      fill: "#fdf3ea",
      stroke: "#fdf3ea",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.66,68.31c4.6,0,9.44-1.17,13.91.17,1.85,3.13.77,6.91-.12,10.18-3.78,0-7.57-.34-11.32.09-2.06.76-1.65,3.4-.86,5,4.16.87,8.43.34,12.61,0,1.17,8.34.26,16.8.61,25.19.09,5.59.43,11.24-.74,16.76a119.7,119.7,0,0,0-13.26,0l-.35,1.24.52,1a119.14,119.14,0,0,0,14.51-.52,92,92,0,0,0-.32,12.2c-5.18.22-10.37.35-15.54.07q-.13-3.36-.1-6.72l2.09-.27c3.89-.11,7.78-.05,11.68-.09l-.08-2q-6.21.12-12.41.13h-1.14c-.28-10.92.09-21.84,0-32.76-.07-4-.54-8-.15-12C368.89,80.06,367.63,74.15,368.66,68.31Z",
    style: {
      fill: "#eb5f5c",
      stroke: "#eb5f5c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,68.86a159.38,159.38,0,0,1,16.93.2c.34,3.61-.52,7.22,0,10.83a98.82,98.82,0,0,1,.86,13C80,108.15,80,123.43,80,138.71a104.36,104.36,0,0,1-17.59.06c-.66-16-.07-31.94-.34-47.91a21.9,21.9,0,0,1,.83-7.6l.94.13a55.23,55.23,0,0,0,14.53.38c-.09-1.81-.19-3.61-.28-5.42-4.71.12-9.47-.43-14.13.46l-1.66.61A53.23,53.23,0,0,1,62.3,68.86Z",
    style: {
      fill: "#81b7dd",
      stroke: "#81b7dd",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58,80c-.06-3.84,0-7.69.13-11.52,3.14.07,6.27.08,9.4.31l.83.83c-.39,23.61,0,47.21-.21,70.82q-5,.12-10.07.1C168.57,120.31,168.69,100.13,168.58,80Z",
    style: {
      fill: "#e8605e",
      stroke: "#e8605e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.42,68.53c4,.18,8,0,12,0,.11,24-.08,48,0,72q-6,.06-12,0Q263.41,104.55,263.42,68.53Z",
    style: {
      fill: "#f8f2ef",
      stroke: "#f8f2ef",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.78,71.14a42,42,0,0,1,6.43-.55c13,0,26,.11,39,0a24.57,24.57,0,0,1,5.42.23c2.78.88,1.56,4.13,1.91,6.29a19.85,19.85,0,0,1-9.31,1.39c-14.49-.11-29,0-43.47-.08C113.76,76,113.76,73.55,113.78,71.14Z",
    style: {
      fill: "#d8d3d6",
      stroke: "#d8d3d6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.94,69.57l1.8,1.83q.07,4,.11,8c0,.53,0,1.59,0,2.12q-.15,26.9-.05,53.8l0,1.9c-.79,3.23,2.47,3.37,4.76,4l-.35,1.26q-14,.12-28.07,0l-.52-1.74c3.06-.14,6.13-.22,9.2-.28.42-19.68-.24-39.38.4-59L168.58,80c.11,20.18,0,40.36.08,60.54q5,0,10.07-.1C178.92,116.78,178.55,93.18,178.94,69.57Z",
    style: {
      fill: "#711a1f",
      stroke: "#711a1f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.93,70.15c5.5,0,11-.06,16.52.08a58.08,58.08,0,0,0-.37,7.69q.07,31.32-.06,62.63c-5.41,0-10.81-.12-16.22.06C349,117.13,348.69,93.64,348.93,70.15Z",
    style: {
      fill: "#f7956a",
      stroke: "#f7956a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.87,70.85c2.59,1.22,2.66,6.14-.23,6.94a31.17,31.17,0,0,1-.07-3.74c.05-.53.14-1.57.19-2.09Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,71.4l5.37-.28c.09,2.78.17,5.56.41,8.33-1.89,0-3.78,0-5.67,0Q180.82,75.43,180.74,71.4Z",
    style: {
      fill: "#b4555e",
      stroke: "#b4555e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.25,72.1c16.17-.21,32.34.16,48.51-.14,0,.52-.14,1.56-.19,2.09-1.4.75-2.77-.1-4.08-.55-2.31.86-4.73,1.8-7.24,1.29-11.91-2-24.06.19-36-1.4l.16,2.29c13.92.3,27.85,0,41.78.08a6.75,6.75,0,0,1,4.63,1.32c-15.88.32-31.81-.46-47.68.43C115.17,75.71,115.2,73.9,115.25,72.1Z",
    style: {
      fill: "#d9d5da",
      stroke: "#d9d5da",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.54,74.41c6.72,0,13.44.16,20.16-.14q0,33.14,0,66.27c-6.73.07-13.46,0-20.19,0q-.06-32.34,0-64.68C326.53,75.52,326.53,74.78,326.54,74.41Z",
    style: {
      fill: "#b2c2d8",
      stroke: "#b2c2d8",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.44,74.85a22.73,22.73,0,0,1,5.27.3c-.19,21.77-.12,43.55-.11,65.32l-5.24.06c.35-6.88-.71-13.75-.05-20.62C237.51,104.89,237.26,89.87,237.44,74.85Z",
    style: {
      fill: "#98bfde",
      stroke: "#98bfde",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,74.61l4.82,0q0,32.94,0,65.88l-4.86.11C256.84,118.58,256.67,96.59,256.78,74.61Z",
    style: {
      fill: "#f3c3b4",
      stroke: "#f3c3b4",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.66,75.31c5.7,0,11.4.08,17.09,0-.1,21.69,0,43.38,0,65.07-5.69-.11-11.39-.14-17.08,0C284.8,118.7,284.58,97,284.66,75.31Z",
    style: {
      fill: "#98bfde",
      stroke: "#98bfde",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.31,75a58.22,58.22,0,0,1,19,.27c-.93,21.76.26,43.57-.65,65.34-6.28,0-12.55.11-18.82-.08q.11-27.3.11-54.58A77,77,0,0,1,305.31,75Z",
    style: {
      fill: "#596f86",
      stroke: "#596f86",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.34,75.91c5.26-.14,10.53-.08,15.8,0a47.24,47.24,0,0,1-.32,9.66c-5.18-.21-10.36-.13-15.54-.1A29.67,29.67,0,0,1,285.34,75.91Z",
    style: {
      fill: "#4c7e9e",
      stroke: "#4c7e9e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.55,76.44c4.66,0,9.53-1.29,14.05.17,1.54,2.12.65,5,.9,7.4-5.2-.06-10.39-.11-15.58-.1A23.45,23.45,0,0,1,307.55,76.44Z",
    style: {
      fill: "#4a7a98",
      stroke: "#4a7a98",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.35,75.25l2.17.64q-.13,32.34,0,64.68l-2.79,0C324.61,118.82,323.42,97,324.35,75.25Z",
    style: {
      fill: "#332e46",
      stroke: "#332e46",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,76.63c5-1.44,10.44-1.13,15.58-.43a24.13,24.13,0,0,1,.09,9.2c-.66,3.5.31,7,.52,10.48.35,14-.23,28,0,42l-.43.79c-3.74,1.19-7.83.4-11.72.67-1.71-.26-4.42.7-5.21-1.42-.14-19,0-38-.17-57C328.07,79.55,327.34,77.1,329.16,76.63Z",
    style: {
      fill: "#91c2e6",
      stroke: "#91c2e6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,78.81c4.66-.89,9.42-.34,14.13-.46.09,1.81.19,3.61.28,5.42a55.23,55.23,0,0,1-14.53-.38C63.86,81.86,63.91,80.34,64,78.81Z",
    style: {
      fill: "#3f657c",
      stroke: "#3f657c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.39,78.11h4.87c-.49,20.79-.06,41.58-.25,62.38-1.56,0-3.12,0-4.67,0C277.41,119.73,277.36,98.92,277.39,78.11Z",
    style: {
      fill: "#9fc2e0",
      stroke: "#9fc2e0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.73,81.09a21.68,21.68,0,0,1,6.07-2.72c14.49.13,29,0,43.47.08l-2.73,2.79c-7.29-.12-14.58.06-21.87-.1-1.09-.38-2.18-.76-3.26-1.16a44.62,44.62,0,0,0-.8,10.25c3-1.49,2.25-5,2.43-7.8l1.38,1.71c.26,1.93.32,3.87.42,5.81a41.76,41.76,0,0,0-4.1,1.34l0,.32c-.14,2.32-.21,4.65-.38,7,0,.47-.1,1.4-.14,1.87-1.49,13.24.36,26.64-1,39.89l-.68.06c.14-19.69-.16-39.38.13-59.06C120.31,81.05,114,81.38,107.73,81.09Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,79.43c1.89,0,3.78,0,5.67,0l0,.84,0,.14-.21.93c-1.83.1-3.66.13-5.49.19C180.84,81,180.85,80,180.85,79.43Z",
    style: {
      fill: "#ffafa7",
      stroke: "#ffafa7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.27,83.71c-.79-1.56-1.2-4.2.86-5,3.75-.43,7.54-.11,11.32-.09.11,1.68.25,3.35.43,5C378.7,84.05,374.43,84.58,370.27,83.71Z",
    style: {
      fill: "#913235",
      stroke: "#913235",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.41,80c1.08.4,2.17.78,3.26,1.16l-2.33,0c.17.33.53,1,.7,1.31-.18,2.75.56,6.31-2.43,7.8A44.62,44.62,0,0,1,129.41,80Z",
    style: {
      fill: "#613449",
      stroke: "#613449",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.24,80.24c4.15,0,8.31-.13,12.45.21,0,1.58-.07,3.17-.1,4.75-3.82.07-7.66.35-11.49,0C350,84.52,351.38,81.85,351.24,80.24Z",
    style: {
      fill: "#8b5237",
      stroke: "#8b5237",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.53,140.72c.11-19.87-.16-39.76.2-59.63,6.28.29,12.58,0,18.86.25-.29,19.68,0,39.37-.13,59.06C120.15,140.82,113.83,140.33,107.53,140.72Z",
    style: {
      fill: "#93c2e4",
      stroke: "#93c2e4",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.34,81.12l2.33,0c7.29.16,14.58,0,21.87.1q-.06,2.07-.09,4.14l-8.55.09c-.15,1.1-.3,2.2-.44,3.3-2.1-.14-4.2-.28-6.3-.38Q138.65,92,138,95.61c-.42-1.86-.81-3.73-1.2-5.6-1.33,0-2.67-.08-4-.06-.1-1.94-.16-3.88-.42-5.81L131,82.43C130.87,82.1,130.51,81.45,130.34,81.12Z",
    style: {
      fill: "#e6dcdb",
      stroke: "#e6dcdb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.41,81.16c3.28,0,6.57,0,9.84.27-.64,19.67,0,39.37-.4,59-3.07.06-6.14.14-9.2.28-1.23-12.57-.31-25.25-.35-37.86C156.59,95.65,155.64,88.39,156.41,81.16Z",
    style: {
      fill: "#d36160",
      stroke: "#d36160",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.54,80.43a19.36,19.36,0,0,1,1,5.48c0,14.69-.24,29.38,0,44.07a29.46,29.46,0,0,1-.94,6.45l-.24-.94c-.68-10.15-.14-20.35-.27-30.52.22-7.87-.43-15.76.23-23.61Z",
    style: {
      fill: "#64252c",
      stroke: "#64252c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.34,82.13c5.63-.87,11.39-.45,17,0-.41,2.53-3.36,1.81-5.19,2-3.91-.21-8,.47-11.76-.51C86.41,83.23,86.36,82.5,86.34,82.13Z",
    style: {
      fill: "#ffb2ae",
      stroke: "#ffb2ae",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84,81.55c1.83-.06,3.66-.09,5.49-.19-.66,7.85,0,15.74-.23,23.61.13,10.17-.41,20.37.27,30.52-1.86-.09-3.72-.11-5.58-.14Q180.7,108.44,180.84,81.55Z",
    style: {
      fill: "#bb585f",
      stroke: "#bb585f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.24,84.05c1.91-.39,5.24-2.14,5.94.82.65,11,.06,22,.3,33-.2,4.59.51,9.3-.47,13.82-2.2,1.79-7,.69-6.16-2.83C158.09,114,157.67,99,158.24,84.05Z",
    style: {
      fill: "#ec605d",
      stroke: "#ec605d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.92,83.91c5.19,0,10.38,0,15.58.1,0,.53,0,1.59,0,2.12-5.2.05-10.39,0-15.58,0C306.93,85.56,306.92,84.46,306.92,83.91Z",
    style: {
      fill: "#9bc9e7",
      stroke: "#9bc9e7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.28,85.5c5.18,0,10.36-.11,15.54.1H301l.2,1.74c-5.31,0-10.62.05-15.93.07C285.25,86.94,285.27,86,285.28,85.5Z",
    style: {
      fill: "#b4e0fb",
      stroke: "#b4e0fb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.46,88.77c.14-1.1.29-2.2.44-3.3l8.55-.09c0,.48,0,1.45,0,1.94l-6.87-.13c-.33,17.8-.1,35.6-.15,53.4,1.7,0,3.41,0,5.12,0l-.61,1.88c-15.51-.08-31,.11-46.52,0l.11-1.62,2-.11c6.3-.39,12.62.1,18.93-.32l.68-.06c1.4-13.25-.45-26.65,1-39.89.93,11.28-.08,22.62.55,33.92,3.28-11.66,6.35-23.53,6.76-35.7,0-2.29,0-4.58,0-6.87l-6.75-.19,0-.32a41.76,41.76,0,0,1,4.1-1.34c1.33,0,2.67,0,4,.06.39,1.87.78,3.74,1.2,5.6q.61-3.6,1.12-7.22C141.26,88.49,143.36,88.63,145.46,88.77Z",
    style: {
      fill: "#44212a",
      stroke: "#44212a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.94,86.11c5.19,0,10.38.07,15.58,0-.25,13.26,0,26.51-.07,39.77a28.29,28.29,0,0,1-.9,7c-4.87,0-9.73-.05-14.59,0Q307,109.51,306.94,86.11Z",
    style: {
      fill: "#497a97",
      stroke: "#497a97",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57,87.19l6.87.13c.18,17.71-.12,35.42.09,53.14l-2,.13c-1.71,0-3.42,0-5.12,0C147.47,122.79,147.24,105,147.57,87.19Z",
    style: {
      fill: "#fff3ee",
      stroke: "#fff3ee",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81,86.21c4.65-.09,9.3-.07,13.94,0,0,1.74,0,3.47,0,5.21-4.66.12-9.32.18-14,0C329.78,89.62,329.8,87.91,329.81,86.21Z",
    style: {
      fill: "#40667f",
      stroke: "#40667f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,88.14c5.4-.76,10.88-.46,16.32-.4,1.42-.72,2.67,2.13.84,2a96.6,96.6,0,0,1-13.07.15A5.11,5.11,0,0,1,85,88.14Z",
    style: {
      fill: "#fba8a5",
      stroke: "#fba8a5",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.23,87.42c5.31,0,10.62,0,15.93-.07.25,15.29-.24,30.59.29,45.86-5.37-.4-10.75-.28-16.12-.25-.53-5.68-.07-11.37-.15-17.05C285.22,106.41,284.72,96.91,285.23,87.42Z",
    style: {
      fill: "#4c7f9f",
      stroke: "#4c7f9f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.86,90.29l4.7,1.28c0,1.32.05,2.64.1,4l-.6-.52c-1.25-1.2-3-1.58-4.61-2.06C140.55,92.28,140.76,91,140.86,90.29Z",
    style: {
      fill: "#e0a18f",
      stroke: "#e0a18f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44,95.6c.17-1.68.29-3.36.41-5,3.87.14,7.75-.1,11.62,0,1.62,1.16.78,3.31,1,5C119.11,95.7,114.78,95.72,110.44,95.6Z",
    style: {
      fill: "#3e6178",
      stroke: "#3e6178",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.7,91.61l6.75.19c0,2.29.09,4.58,0,6.87-2.39,0-4.78-.07-7.17-.09C128.49,96.26,128.56,93.93,128.7,91.61Z",
    style: {
      fill: "#557d9b",
      stroke: "#557d9b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,93c.41,13.29,0,26.59.14,39.89a23.17,23.17,0,0,1-.42,5.32c-5,1.23-10.2.36-15.28.47A11.34,11.34,0,0,1,110.3,134c4.77,0,9.71.74,14.3-1-4.43-2.24-9.46-1-14.19-1.16-1.72-.35-.73-2.8-1.11-4,.06-9,.09-18,0-26.94a10.86,10.86,0,0,1,1.14-5.31c4.34.12,8.67.1,13,0H124C124.23,94.93,124.59,93.65,124.78,93Z",
    style: {
      fill: "#8ec2e7",
      stroke: "#8ec2e7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45,93c1.61.48,3.36.86,4.61,2.06l-.12,2.21c-1.68-.74-3.36-1.47-5-2.29l-.22-1.21Z",
    style: {
      fill: "#f8d3be",
      stroke: "#f8d3be",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,94.93c1.63.82,3.31,1.55,5,2.29-2.11,7.69-3.6,15.52-5.31,23.31a82.82,82.82,0,0,0-2.25,11.24l-.74-.45a22.43,22.43,0,0,0-4.5-1.95C134.93,117.94,137.11,106.35,140,94.93Z",
    style: {
      fill: "#f2bca6",
      stroke: "#f2bca6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.32,98.58c2.39,0,4.78.06,7.17.09-.41,12.17-3.48,24-6.76,35.7-.63-11.3.38-22.64-.55-33.92C128.22,100,128.28,99.05,128.32,98.58Z",
    style: {
      fill: "#5a809c",
      stroke: "#5a809c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77,140.31c-1.31-11.77,3-23,5-34.39a208.2,208.2,0,0,1,.09,34.69Z",
    style: {
      fill: "#4e7289",
      stroke: "#4e7289",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.14,126.87l.35-1.24a119.7,119.7,0,0,1,13.26,0l1.42,1.7a119.14,119.14,0,0,1-14.51.52Z",
    style: {
      fill: "#fcaca6",
      stroke: "#fcaca6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.58,127.6c3.87-.23,7.75-.06,11.63-.1A2.64,2.64,0,0,1,79,128.61c-.94,1.1-2.45.88-3.73.95a98.62,98.62,0,0,1-10.74-.24C63.31,129.76,63.54,127.2,64.58,127.6Z",
    style: {
      fill: "#335875",
      stroke: "#335875",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.59,130.45c4.22.08,8.43,0,12.65.05,1.19-.15,2.1.63,3,1.25a40.76,40.76,0,0,1-16.86.16Z",
    style: {
      fill: "#972525",
      stroke: "#972525",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.14,129.37a22.43,22.43,0,0,1,4.5,1.95l.37,1.45c-1.73-.36-3.45-.74-5.17-1.12C131.91,131.08,132.06,129.94,132.14,129.37Z",
    style: {
      fill: "#fbd2c0",
      stroke: "#fbd2c0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.35,130.62c4.55-1.38,9.41-.62,14.1-1,.17.54.52,1.64.7,2.18a64,64,0,0,1-14.31.13Z",
    style: {
      fill: "#496c8c",
      stroke: "#496c8c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.49,130.65q6.21,0,12.41-.13l.08,2c-3.9,0-7.79,0-11.68.09Z",
    style: {
      fill: "#a12b2c",
      stroke: "#a12b2c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41,131.88c4.73.19,9.76-1.08,14.19,1.16-4.59,1.7-9.53,1-14.3,1C110.33,133.47,110.39,132.41,110.41,131.88Z",
    style: {
      fill: "#4b6d8d",
      stroke: "#4b6d8d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.61,139.35c.72-2.57,1.48-5.14,2.23-7.7,1.72.38,3.44.76,5.17,1.12a79.89,79.89,0,0,0-2.34,7.68Q132.14,140,129.61,139.35Z",
    style: {
      fill: "#f6b9ab",
      stroke: "#f6b9ab",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14,132.56c4.41-1,10-2.27,13.93.53C359.47,133.39,354.55,134.24,350.14,132.56Z",
    style: {
      fill: "#87453b",
      stroke: "#87453b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,133c5.37,0,10.75-.15,16.12.25-.12.35-.35,1.06-.47,1.41-5.18.95-10.48.46-15.71.47C285.28,134.55,285.31,133.49,285.33,133Z",
    style: {
      fill: "#9bc7e4",
      stroke: "#9bc7e4",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.82,135.33a3.76,3.76,0,0,1,.14-2.44c4.86-.07,9.72,0,14.59,0l.89,0,0,2.22C317.26,135.25,312,135.08,306.82,135.33Z",
    style: {
      fill: "#97c5e2",
      stroke: "#97c5e2",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,136.71c.66-3.58,5-1.68,7.49-2C177.22,138.58,172.52,136.52,170,136.71Z",
    style: {
      fill: "#ad3436",
      stroke: "#ad3436",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.79,135.35c1.86,0,3.72.05,5.58.14l.24.94,0,.15c-2,.19-3.88.48-5.82.67Z",
    style: {
      fill: "#f3c3ab",
      stroke: "#f3c3ab",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.38,135.22H253l-.08,2.16q-3.19,0-6.38,0C246.52,136.82,246.43,135.75,246.38,135.22Z",
    style: {
      fill: "#a22a27",
      stroke: "#a22a27",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.27,135.09c5.23,0,10.53.48,15.71-.47.14,1.72.23,3.45.29,5.19a128.6,128.6,0,0,1-16.07,0C285.22,138.26,285.24,136.67,285.27,135.09Z",
    style: {
      fill: "#4c7d9c",
      stroke: "#4c7d9c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.82,135.33c5.21-.25,10.44-.08,15.66-.2-.19,1.18-.37,2.37-.54,3.55-5,.12-10.33,1.4-15.16-.47Z",
    style: {
      fill: "#477895",
      stroke: "#477895",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.37,136.21l7.61.06c0,1.15,0,2.3,0,3.46-2.58,0-5.16,0-7.73,0C157.3,138.52,157.33,137.36,157.37,136.21Z",
    style: {
      fill: "#e46666",
      stroke: "#e46666",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.83,137.25c1.94-.19,3.87-.48,5.82-.67-.36,1.55-.65,3.11-1.06,4.65C183.3,140.62,180,140.48,180.83,137.25Z",
    style: {
      fill: "#ac5c56",
      stroke: "#ac5c56",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.46,142.54c2.51,0,5,0,7.53-.07h.59c14.61,0,29.22-.07,43.83,0,15.5.13,31-.06,46.52,0,1.75,0,3.49,0,5.24,0q14,.09,28.07,0c12.17,0,24.34.08,36.51-.05,42.18.09,84.38,0,126.57.07,13.81,0,27.64.27,41.45-.25h0c.09,2.08.13,4.17.18,6.25-112.21.11-224.43-.13-336.64.1C53.37,146.59,53.42,144.56,53.46,142.54Z",
    style: {
      fill: "#f69774",
      stroke: "#f69774",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.94,150.61a11.12,11.12,0,0,1,8.59,1.17c3.26,1.88,7.1.9,10.65,1,12.69,0,25.38.31,38.06-.17,6.7-.25,13.37.68,20.07.65,8.22.22,16.49-.61,24.67.42,0,1.91-.07,3.81,0,5.72l1.08,0-.53,2-.12.57c-1.15,17.69-.07,35.47-.6,53.19-.91.74-1.82,1.47-2.72,2.22-7.25,0-14.5,0-21.75,0l-1.84-2c-.09-20-.12-40,0-59.92-7.59-.35-15.18-.09-22.77-.15-.1,20.06-.28,40.14,0,60.2l.31,1.88c-16.61,0-33.21,0-49.82,0,.06-.58.17-1.73.23-2.31.43-18.38,0-36.78.28-55.16a37.26,37.26,0,0,0-.22-6C58.76,152.45,57.12,151.7,55.94,150.61Z",
    style: {
      fill: "#421f23",
      stroke: "#421f23",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.16,150.81c17.68,0,35.38.09,53,.08,12.52,1.18,25.15-.6,37.63.84a97.42,97.42,0,0,1-14.06,1.15c-9.28-1-18.62-.2-27.92-.5-11.52-.45-23.05,0-34.58-.09q-63.52,0-127,0c-5.58,0-11.16,0-16.74-.22a14,14,0,0,1,6.76-1.35c16.65.19,33.31-.16,50,.22C240.53,150.43,264.85,151.46,289.16,150.81Z",
    style: {
      fill: "#854744",
      stroke: "#854744",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.46,151.09l2.48-.48c1.18,1.09,2.82,1.84,3.56,3.33a37.26,37.26,0,0,1,.22,6c-.24,18.38.15,36.78-.28,55.16l-6-.19C53.42,193.62,53.46,172.35,53.46,151.09Z",
    style: {
      fill: "#86433a",
      stroke: "#86433a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,151.78c17.57-.55,35.16-.05,52.74-.27,5.69-.15,11.29,1.29,17,1,8.41-.31,16.85.41,25.24-.41,5.58.26,11.16.26,16.74.22q63.52.06,127,0c11.53.06,23.06-.36,34.58.09,9.3.3,18.64-.54,27.92.5a97.42,97.42,0,0,0,14.06-1.15,18,18,0,0,1,6.51,2.09c.68,16,0,32.08.21,48.12,0,4.36.23,8.76-.62,13.07l-1.26.11q-.07-29.91,0-59.81a121.3,121.3,0,0,0-12.21-.06l-.46,0-4.17.13h-.12l-2,.12c-4.12.21-8.3-.36-12.38.41a20.78,20.78,0,0,0-.44,4c0,18.45.09,36.9,0,55.36h-2c0-20.05.1-40.1.05-60.15-4.83-.1-9.67.19-14.49-.17l-1.22-.25a22.83,22.83,0,0,0-3.93-.56c-53.68-.09-107.35,0-161,0a74.66,74.66,0,0,1-12.24-.49c-8.18-1-16.45-.2-24.67-.42-6.7,0-13.37-.9-20.07-.65-12.68.48-25.37.16-38.06.17C71.63,152.68,67.79,153.66,64.53,151.78Z",
    style: {
      fill: "#3e222f",
      stroke: "#3e222f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.35,153.82c.19-1.95,1.9-2.59,3.49-3.18,0,22.05.07,44.11-.07,66.17l-.5-.06a8.46,8.46,0,0,0-3.33-1.74c.85-4.31.66-8.71.62-13.07C386.34,185.9,387,169.84,386.35,153.82Z",
    style: {
      fill: "#854643",
      stroke: "#854643",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,159.39c-.05-1.91,0-3.81,0-5.72a74.66,74.66,0,0,0,12.24.49c53.67,0,107.34-.07,161,0a22.83,22.83,0,0,1,3.93.56l-1.61,1.73c-4.66.63-9.39,0-14.08.18-.26,1-.52,2-.77,3-6.82-1-13.68-.56-20.5.08-6.78-.27-13.58-.15-20.34-.7l-.78-.46a119.48,119.48,0,0,0-15-.1c-.31,1.13-.61,2.27-.91,3.41-3.81,0-7.63,0-11.44.18-.15,1.55-.29,3.1-.44,4.66-3.24,0-6.48,0-9.72-.05l-1.81-2c-8.44.11-16.86-.61-25.29-.72-.13-1.26-.29-2.52-.47-3.77q-6.41-.1-12.8,0a39,39,0,0,1-1.2,6.52,96.39,96.39,0,0,1-10.2-.14c3-.16,6.3.54,9.12-.85-.09-.21-.29-.64-.38-.86a52.53,52.53,0,0,0-8.68-.48c0-1.32-.07-2.64-.1-4-9.6.13-19.11-1.48-28.71-.91Z",
    style: {
      fill: "#e5dad9",
      stroke: "#e5dad9",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.56,155.17c6.74-.2,13.49,0,20.24-.09q0,30.13,0,60.28c-6.78-.09-13.55.11-20.32-.09C61.69,195.24,61.64,175.2,61.56,155.17Z",
    style: {
      fill: "#fef4eb",
      stroke: "#fef4eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.54,154.84l2.3,1c-.27,19.82-.12,39.65-.19,59.48l-2.1.43C82.49,195.45,82.57,175.14,82.54,154.84Z",
    style: {
      fill: "#422429",
      stroke: "#422429",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.86,155.09c6.87.12,13.76-.26,20.62.22,0,8.83-.78,17.66-.21,26.5.32,5.69-.42,11.37-.09,17.06a123.51,123.51,0,0,1-.28,16.55c-6.75-.16-13.5,0-20.25-.1.07-19.83-.08-39.66.19-59.48Z",
    style: {
      fill: "#fef4eb",
      stroke: "#fef4eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,155.29c7.59.06,15.18-.2,22.77.15-.16,20-.13,39.95,0,59.92-7.59,0-15.17-.07-22.76.13C108.47,195.43,108.65,175.35,108.75,155.29Z",
    style: {
      fill: "#f3996f",
      stroke: "#f3996f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.17,154.74l1.22.25c.24,20.15-.24,40.33.26,60.48l-2.6-.07c.59-18.59.26-37.21.24-55.8l-.81-.86c-4-.33-8.07-.13-12.11-.07l-1.53.05-.36-2.07c4.69-.14,9.42.45,14.08-.18Z",
    style: {
      fill: "#42273c",
      stroke: "#42273c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.39,155c4.82.36,9.66.07,14.49.17.05,20.05,0,40.1-.05,60.15-4.73.1-9.46-.13-14.18.16C336.15,195.32,336.63,175.14,336.39,155Z",
    style: {
      fill: "#94c2e3",
      stroke: "#94c2e3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.72,155.52l2-.12h.12c.11,20,0,39.92,0,59.88h-2.1L365.2,210c-.72-10-.1-20.06-.31-30.09.06-5.48-.32-11,.54-16.42A79.31,79.31,0,0,0,365.72,155.52Z",
    style: {
      fill: "#2a1a2d",
      stroke: "#2a1a2d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.89,155.54c7.26-.31,14.51-.07,21.77-.12.51,13.81,0,27.64.19,41.46,0,6.15.13,12.3-.22,18.45-7.27-.11-14.53.15-21.8-.07Q133.86,185.4,133.89,155.54Z",
    style: {
      fill: "#4c7fa0",
      stroke: "#4c7fa0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.34,155.93c4.08-.77,8.26-.2,12.38-.41a79.31,79.31,0,0,1-.29,8,75.51,75.51,0,0,0-12,.65l1.79,1.24c-.16,6.8-1.44,13.58-.58,20.39a94.36,94.36,0,0,1,.1,22.47c-.08.67-.15,1.35-.22,2,3.57-.06,7.14-.14,10.71-.27l.57,5.23c-4.31,0-8.61,0-12.91,0,.13-18.46,0-36.91,0-55.36A20.78,20.78,0,0,1,353.34,155.93Z",
    style: {
      fill: "#527e9d",
      stroke: "#527e9d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,155.4l4.17-.13c-2.1,2.5-2,5.74-1.6,8.79.08,1.53.13,3.07.09,4.6-.82,7.4-.35,14.83-.49,22.25s-.13,14.65.34,22a25,25,0,0,0,12.46,0c0-1.89,0-3.77,0-5.65,0-.56,0-1.66,0-2.21.32-13.76,0-27.51.13-41.26,0-2.23-.06-4.45-.1-6.67-3.52-.2-7.19-.15-10.38-1.86a121.3,121.3,0,0,1,12.21.06q-.06,29.9,0,59.81c-5.6.43-11.21.19-16.81.16C367.86,195.32,368,175.36,367.87,155.4Z",
    style: {
      fill: "#a4b9d7",
      stroke: "#a4b9d7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,155.27l.46,0c3.19,1.71,6.86,1.66,10.38,1.86,0,2.22.09,4.44.1,6.67h-.4a117,117,0,0,0-12.14.29C370.07,161,369.94,157.77,372,155.27Z",
    style: {
      fill: "#91c1e5",
      stroke: "#91c1e5",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.71,159.62c.25-1,.51-2,.77-3l.36,2.07,1.53-.05c-.43,18.89-.31,37.79-.25,56.69h-.74c.48-18.38.1-36.77.12-55.15a47.33,47.33,0,0,1-5.46-.3c-7-1.39-14,.86-21.05.58-5.16-.34-10.34-.32-15.5-.2l-.62-1.29c6.76.55,13.56.43,20.34.7C305,159.06,311.89,158.66,318.71,159.62Z",
    style: {
      fill: "#937374",
      stroke: "#937374",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.41,157c3.53-.11,7.07-.11,10.61,0q.09,3.4.14,6.83-5.46,0-10.89-.19C338.33,161.47,338.36,159.25,338.41,157Z",
    style: {
      fill: "#91c2e4",
      stroke: "#91c2e4",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.07,158.44a119.48,119.48,0,0,1,15,.1l.78.46.62,1.29-2,0c-4.23,0-8.47,0-12.7,0-.13,17.91.06,35.82-.13,53.73l-2.09.82c.37-16.9,0-33.8.22-50.7-3.33,0-6.65.06-10,0-.12-.38-.37-1.12-.49-1.5,3.55-.23,7.11-.14,10.67-.16C262,161.12,262.05,159.78,262.07,158.44Z",
    style: {
      fill: "#553015",
      stroke: "#553015",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.16,161.85c.3-1.14.6-2.28.91-3.41,0,1.34,0,2.68,0,4-3.56,0-7.12-.07-10.67.16l-.77.28c-.22,1.48-.39,3-.57,4.45q-5.72-.11-11.43,0c-.37-.53-1.09-1.59-1.45-2.12-7.81.65-15.57-1.53-23.33-.53-.1.21-.32.63-.42.84,3.2.5,6.46,0,9.68.48.62,16.41-.12,32.87.33,49.3h-1c0-1.56.09-3.12.14-4.68-2.86-.11-5.72-.28-8.58-.54,2.4.08,4.81,0,7.21,0V208.6c-2.87,0-6-.48-8.45,1.41-.05,1.76,0,3.51,0,5.27l-.66-.29c.29-17-.43-34.07.37-51.09,8.43.11,16.85.83,25.29.72l1.81,2c3.24,0,6.48,0,9.72.05.15-1.56.29-3.11.44-4.66C253.53,161.87,257.35,161.82,261.16,161.85Z",
    style: {
      fill: "#ac9ba2",
      stroke: "#ac9ba2",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.37,158.67c4-.06,8.08-.26,12.11.07l.81.86c0,18.59.35,37.21-.24,55.8-4.31-.05-8.62,0-12.93,0C321.06,196.46,320.94,177.56,321.37,158.67Z",
    style: {
      fill: "#fff3eb",
      stroke: "#fff3eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,159.42c9.6-.57,19.11,1,28.71.91,0,1.32.06,2.64.1,4a52.53,52.53,0,0,1,8.68.48c.09.22.29.65.38.86-2.82,1.39-6.09.69-9.12.85.16,2.22.35,4.44.47,6.67l0,2.14c-.73,10.42-.18,20.87-.3,31.3,0,2.95.08,5.91.33,8.85,3.46,0,6.93-.07,10.39-.24l1.74,2.18q-22.66,0-45.31,0c.9-.75,1.81-1.48,2.72-2.22,5.26.27,10.53.13,15.79,0,0-17.9,0-35.8.06-53.7-5,0-10.09,0-15.13-.1Z",
    style: {
      fill: "#5e0f16",
      stroke: "#5e0f16",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.19,160.1q6.41-.07,12.8,0c.18,1.25.34,2.51.47,3.77-.8,17-.08,34.06-.37,51.09l.66.29c3.23.17,6.46.09,9.69.05H225c3.82,0,7.64,0,11.46-.13l2.11,0,.73,0a93.26,93.26,0,0,0,9.75,0l.67,0h2.15c3.07.08,6.15.16,9.23.2l1.44,1.94c-20.72.21-41.45,0-62.17.06l-1.74-2.18c0-.83,0-2.5,0-3.33-.23-12.19.47-24.41-.4-36.58,0-.53.07-1.6.1-2.13a20,20,0,0,0-.32-6.54A39,39,0,0,0,199.19,160.1Z",
    style: {
      fill: "#4b1e21",
      stroke: "#4b1e21",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.51,160.32l2,0c5.16-.12,10.34-.14,15.5.2l-1,1-.1.1c-4.7,0-9.41-.19-14.11-.14.19,18.05-.06,36.11.12,54.17,4.63-.34,9.29-.13,13.93-.17h2.62l6.3,0h2l10.73,0c-.2-18-.26-36.08,0-54.1.12-.33.37-1,.5-1.33a47.33,47.33,0,0,0,5.46.3c0,18.38.36,36.77-.12,55.15h.74c4.31,0,8.62,0,12.93,0l2.6.07c-.23.47-.69,1.41-.93,1.88q-36.59.06-73.17,0l-1.44-1.94,2.56-.76v.73c4.11.11,8.22,0,12.33.05C276.94,197.07,276.12,178.68,276.51,160.32Z",
    style: {
      fill: "#4c130a",
      stroke: "#4c130a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,160.49c7.05.28,14-2,21.05-.58-.13.34-.38,1-.5,1.33-3.57,0-7.14-.09-10.71,0,.19,18,.1,36.06,0,54.09h-2c.53-14.38,0-28.78.13-43.17v-1.9c0-2.69,0-5.38,0-8.07-2.38,0-4.77-.07-7.15-.24l-1.7-.55Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.39,162l.12-.57c5,.09,10.09.06,15.13.1-.07,17.9,0,35.8-.06,53.7-5.26.09-10.53.23-15.79,0,5.14,0,10.29.14,15.42-.27q-.09-4.82-.41-9.61c-4.36-.18-8.81.47-13.12-.29l-1.59-1.24c5.07-.4,10.17-.11,15.26-.29.24-9.78.14-19.58-.08-29.36-4.34.1-8.69.52-13,.07-.45-.31-1.37-.91-1.83-1.21l2.39-.28c3.57-.22,7.14-.13,10.71,0l1.25,0a78,78,0,0,0,.53-10.59A90.53,90.53,0,0,0,158.39,162Z",
    style: {
      fill: "#ffb5b2",
      stroke: "#ffb5b2",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.68,214c.19-17.91,0-35.82.13-53.73,4.23,0,8.47.07,12.7,0-.39,18.36.43,36.75-.5,55.08-4.11-.07-8.22.06-12.33-.05V214Z",
    style: {
      fill: "#f9c880",
      stroke: "#f9c880",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.83,161.29c3.57-.14,7.14,0,10.71,0-.24,18-.18,36.07,0,54.1l-10.73,0C303.93,197.35,304,179.32,303.83,161.29Z",
    style: {
      fill: "#fef3eb",
      stroke: "#fef3eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.39,162a90.53,90.53,0,0,1,14.91.11,78,78,0,0,1-.53,10.59l-1.25,0c-.16-1.48-.31-2.95-.47-4.42-3.57-.05-7.15-.08-10.72-.08l.48,4.54-2.39.28c.46.3,1.38.9,1.83,1.21,4.33.45,8.68,0,13-.07.22,9.78.32,19.58.08,29.36-5.09.18-10.19-.11-15.26.29l1.59,1.24c4.31.76,8.76.11,13.12.29q.31,4.8.41,9.61c-5.13.41-10.28.31-15.42.27C158.32,197.46,157.24,179.68,158.39,162Z",
    style: {
      fill: "#eb615e",
      stroke: "#eb615e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,162a34.64,34.64,0,0,1,9.91.21c-.31,16,0,32-.17,48a34.44,34.44,0,0,0-8-.89c0,.53,0,1.61,0,2.15a27.34,27.34,0,0,0,8.23-1.21c-.06,1.69-.1,3.39-.12,5.09-3.26,0-6.52,0-9.78.07C200.69,197.58,200.72,179.77,200.64,162Z",
    style: {
      fill: "#e5e4f1",
      stroke: "#e5e4f1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.64,162.32c2.88.06,6.08-.81,8.74.49.62,8.35.06,16.76.23,25.13-.16,6.43.47,12.92-.57,19.3-.51-1.05-1-2.08-1.5-3.13-.09.72-.26,2.17-.35,2.89-1.91,0-4.05.84-5.8-.23-1.66-5.1-1-10.56-1.09-15.83C265.61,181.4,265,171.85,265.64,162.32Z",
    style: {
      fill: "#fccd5d",
      stroke: "#fccd5d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.82,161.42c4.7,0,9.41.12,14.11.14l-1.19,1.68c-3.88-.41-7.88-1-11.54.75.21,1.78.41,3.57.7,5.34.21,1.16.44,2.33.68,3.49,3.36.07,6.72,0,10.08-.15l.44,1.85a104.28,104.28,0,0,0-11.86.18,272.33,272.33,0,0,0,.33,32.7c4,.19,8.26-.57,11.85,1.6-3.69,1.77-7.83,1.26-11.78,1.26-.15,1.9.61,4.41-1.7,5.33C278.76,197.53,279,179.47,278.82,161.42Z",
    style: {
      fill: "#c9616a",
      stroke: "#c9616a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.93,161.56l.1-.1c-.39,18,0,36-.16,54-4.64,0-9.3-.17-13.93.17,2.31-.92,1.55-3.43,1.7-5.33,3.95,0,8.09.51,11.78-1.26-3.59-2.17-7.88-1.41-11.85-1.6a272.33,272.33,0,0,1-.33-32.7,104.28,104.28,0,0,1,11.86-.18l-.44-1.85c-.29-1.18-.58-2.37-.85-3.55q-5,0-9.91.21c-.29-1.77-.49-3.56-.7-5.34,3.66-1.7,7.66-1.16,11.54-.75Z",
    style: {
      fill: "#ec615e",
      stroke: "#ec615e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,161.46l1.7.55c.3,2.76.45,5.52.59,8.29l-.08,1.76q-.69,17.7-.06,35.43l.07.72c0,.55.11,1.64.15,2.19,0,.3,0,.91.05,1.21,0,1.26,0,2.53,0,3.8h-2.62C293,197.43,292.64,179.44,293,161.46Z",
    style: {
      fill: "#4f222e",
      stroke: "#4f222e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.73,162c2.38.17,4.77.2,7.15.24,0,2.69.05,5.38,0,8.07h-.73a45.59,45.59,0,0,0-.39-6.18c-.55-1.69-2.69-1.23-3.89-.6-1.64,1.85-.78,4.55-1,6.78l-.57,0C295.18,167.53,295,164.77,294.73,162Z",
    style: {
      fill: "#7869a3",
      stroke: "#7869a3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.23,162.23l2.7,0c.07,17.64,0,35.28.08,52.92l-3.05.17C316.07,197.65,315.63,179.92,316.23,162.23Z",
    style: {
      fill: "#db8c73",
      stroke: "#db8c73",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.66,162.18c3-.1,6.09-.08,9.13.06,0,1.85,0,3.71-.09,5.56q-4.48.12-9,0C176.71,165.94,176.68,164.06,176.66,162.18Z",
    style: {
      fill: "#e35a60",
      stroke: "#e35a60",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,162.91l.77-.28c.12.38.37,1.12.49,1.5.12,17,0,34,0,51.05h-2.15c.17-15.31,0-30.62.15-45.93-3.76-.15-7.51-.19-11.27-.13-.07,15.34.13,30.68,0,46l-2.11,0c0-1.4,0-2.79,0-4.18,0-12.73-.11-25.46.07-38.19-.23-1.78.56-4-.59-5.49a74.61,74.61,0,0,0-10.36-.21c-.1,1.87-.2,3.74-.24,5.61.08,6.75.17,13.5-.22,20.24.11,6,.24,12-.08,17.95,0,1.46,0,2.93,0,4.4H223.4c-.45-16.43.29-32.89-.33-49.3-3.22-.45-6.48,0-9.68-.48.1-.21.32-.63.42-.84,7.76-1,15.52,1.18,23.33.53.36.53,1.08,1.59,1.45,2.12q5.72-.09,11.43,0C250.2,165.87,250.37,164.39,250.59,162.91Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.91,163.55c1.2-.63,3.34-1.09,3.89.6a45.59,45.59,0,0,1,.39,6.18c-1.77,0-3.54,0-5.3,0C296.13,168.1,295.27,165.4,296.91,163.55Z",
    style: {
      fill: "#4d80a1",
      stroke: "#4d80a1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,164.18a75.51,75.51,0,0,1,12-.65c-.86,5.44-.48,10.94-.54,16.42.21,10-.41,20.08.31,30.09-3.57.13-7.14.21-10.71.27.07-.68.14-1.36.22-2,3.27.06,6.55.07,9.83.06.13-14.34,0-28.67.08-43-3.15,0-6.29.14-9.43.09Z",
    style: {
      fill: "#acd8f8",
      stroke: "#acd8f8",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.65,163.47c4.71,0,9.42,0,14.13.05-.45,1.78,1,4.73-1.21,5.59-4.28.16-8.56-.05-12.84.12C64.69,167.31,64.67,165.39,64.65,163.47Z",
    style: {
      fill: "#8c5848",
      stroke: "#8c5848",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.91,163.54c4.85-.1,9.7-.16,14.53.14q-.34,2.76-.68,5.54c-4.4-.15-8.81-.16-13.2.09A23.81,23.81,0,0,1,87.91,163.54Z",
    style: {
      fill: "#8c5348",
      stroke: "#8c5348",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.13,163.69c5.44-.53,11-.19,16.41,0L127.8,165c-5.49.59-11.07.29-16.58.15Z",
    style: {
      fill: "#8a522d",
      stroke: "#8a522d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.85,164.13c3.31.07,6.63,0,10,0-.19,16.9.15,33.8-.22,50.7l2.09-.82v.6l-2.56.76c-3.08,0-6.16-.12-9.23-.2C251.8,198.17,252,181.14,251.85,164.13Z",
    style: {
      fill: "#587a98",
      stroke: "#587a98",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.27,163.69q5.43.17,10.89.19c0,1.61,0,3.22-.06,4.84q-5.42-.1-10.82-.1A36.87,36.87,0,0,1,338.27,163.69Z",
    style: {
      fill: "#3f647c",
      stroke: "#3f647c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.44,164.06a117,117,0,0,1,12.14-.29c.1,1.56.2,3.12.31,4.69-4.12.22-8.24.25-12.36.2C370.57,167.13,370.52,165.59,370.44,164.06Z",
    style: {
      fill: "#3f637a",
      stroke: "#3f637a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.58,163.77h.4c-.17,13.75.19,27.5-.13,41.26-4.19.14-8.75-1-12.68.68l.57,1.4a101.42,101.42,0,0,0,12.08.13c0,1.88,0,3.76,0,5.65a25,25,0,0,1-12.46,0c-.47-7.31-.36-14.64-.34-22s-.33-14.85.49-22.25c4.12.05,8.24,0,12.36-.2C382.78,166.89,382.68,165.33,382.58,163.77Z",
    style: {
      fill: "#90c2e7",
      stroke: "#90c2e7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.19,165.42c3.14.05,6.28,0,9.43-.09-.07,14.34.05,28.67-.08,43-3.28,0-6.56,0-9.83-.06a94.36,94.36,0,0,0-.1-22.47C353.75,179,355,172.22,355.19,165.42Z",
    style: {
      fill: "#4d80a1",
      stroke: "#4d80a1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.36,167.12c4.95-.49,9.92-.31,14.89-.31,1.29,0,2,.74,2.24,2.2-5.5.36-11,.07-16.52.16C136.82,168.66,136.51,167.64,136.36,167.12Z",
    style: {
      fill: "#9dcced",
      stroke: "#9dcced",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.79,166.48a96.39,96.39,0,0,0,10.2.14,20,20,0,0,1,.32,6.54q-5-.1-10.05,0C188.14,170.92,188,168.7,187.79,166.48Z",
    style: {
      fill: "#bb545b",
      stroke: "#bb545b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.83,166.78c3.3-.14,6.6-.15,9.91-.07-.08,1.86-.2,3.73-.39,5.59-2.81-.08-5.63-.14-8.45-.16h-1.14C212.78,170.34,212.79,168.56,212.83,166.78Z",
    style: {
      fill: "#dbdad8",
      stroke: "#dbdad8",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.57,167.11a74.61,74.61,0,0,1,10.36.21c1.15,1.47.36,3.71.59,5.49-3.73-.21-7.47-.24-11.19-.09C225.37,170.85,225.47,169,225.57,167.11Z",
    style: {
      fill: "#537e9c",
      stroke: "#537e9c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.73,166.52c3.31,0,6.63.1,9.95-.05a5,5,0,0,1,0,4.81c-3.26-.13-6.52-.13-9.77-.06C322.82,169.65,322.77,168.09,322.73,166.52Z",
    style: {
      fill: "#80564b",
      stroke: "#80564b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.61,167.54a139.14,139.14,0,0,1,16.84.05l.44,1.72c-4.24-.05-8.49-.07-12.73,0C114.54,169.16,112.07,169.85,111.61,167.54Z",
    style: {
      fill: "#925836",
      stroke: "#925836",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,168.16c3.57,0,7.15,0,10.72.08.16,1.47.31,2.94.47,4.42-3.57-.09-7.14-.18-10.71,0Z",
    style: {
      fill: "#98333b",
      stroke: "#98333b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.73,167.82q4.49.1,9,0c0,.61,0,1.83.06,2.44q-4.53,0-9,0C176.71,169.62,176.73,168.42,176.73,167.82Z",
    style: {
      fill: "#fba89f",
      stroke: "#fba89f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.61,169.12c3.76-.06,7.51,0,11.27.13-.11,15.31,0,30.62-.15,45.93l-.67,0c-.05-1.36-.1-2.71-.14-4.07-.14-10.61,0-21.23-.07-31.85-3.08,0-6.15,0-9.23,0-.18,10.59.13,21.19-.14,31.79,0,1.35-.11,2.71-.17,4.07l-.73,0C238.74,199.8,238.54,184.46,238.61,169.12Z",
    style: {
      fill: "#7e6c9d",
      stroke: "#7e6c9d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,169.33q5-.21,9.91-.21c.27,1.18.56,2.37.85,3.55-3.36.18-6.72.22-10.08.15C281.34,171.66,281.11,170.49,280.9,169.33Z",
    style: {
      fill: "#96333a",
      stroke: "#96333a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.28,168.62q5.4,0,10.82.1c0,12,.06,24,0,36-3.6.05-7.2.08-10.78.41C338.17,193,338.35,180.8,338.28,168.62Z",
    style: {
      fill: "#91c3e6",
      stroke: "#91c3e6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.38,170.14c6.2.2,12.39.12,18.58.11.52,13.58-.22,27.19.68,40.76.33,1.43-1.41,1.61-2.33,2.05-5.57,1.75-11.33-.31-17-.45,0-1.2,0-2.4,0-3.6,5.32,1.22,10.77-.15,16.08.91.29-.45.87-1.37,1.17-1.82,1.05-1,.9-1.78-.45-2.21-5.32-.68-10.7.11-16,0h-.75C110.19,194,110.35,182,110.38,170.14Z",
    style: {
      fill: "#f89569",
      stroke: "#f89569",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,170.22q4.51,0,9,0c0,12.46,0,24.92,0,37.39-2.73.06-5.75-.78-8.23.72l-.69.31C176.54,195.85,176.67,183,176.71,170.22Z",
    style: {
      fill: "#e8605e",
      stroke: "#e8605e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,170.08c2.76-.24,5.54-.12,8.32-.1,0,.5,0,1.48,0,2h-1.24c-2.24,0-4.47,0-6.7-.11l-.7-.66Z",
    style: {
      fill: "#b1d3eb",
      stroke: "#b1d3eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.32,170.3l.57,0c1.76,0,3.53,0,5.3,0h.73v1.9c-2.23,0-4.46-.1-6.68-.16Z",
    style: {
      fill: "#bfecff",
      stroke: "#bfecff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.61,169.25c3.06-.13,6.13-.12,9.19,0,0,.76-.12,2.26-.17,3a9.79,9.79,0,0,1-8.85.09C304.74,171.59,304.65,170,304.61,169.25Z",
    style: {
      fill: "#815d52",
      stroke: "#815d52",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.9,172.14c2.82,0,5.64.08,8.45.16-.45,1-.89,2-1.32,3.08-2.36,0-4.72,0-7.07,0C213.94,174.32,213.91,173.23,213.9,172.14Z",
    style: {
      fill: "#615f5e",
      stroke: "#615f5e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.37,171.86c2.23.13,4.46.11,6.7.11-.19,12.65-.13,25.31-.06,38a57.86,57.86,0,0,0-6,.15C252.65,197.4,254,184.59,253.37,171.86Z",
    style: {
      fill: "#4b7fa0",
      stroke: "#4b7fa0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.24,172.06c2.22.06,4.45.12,6.68.16-.09,14.39.4,28.79-.13,43.17l-6.3,0c0-1.27,0-2.54,0-3.8,2.16-.07,4.32-.18,6.48-.41a24,24,0,0,0-6.53-.8c0-.55-.11-1.64-.15-2.19a22.32,22.32,0,0,0,5.83-.12l-.12-.82c-1.94-.05-3.85.15-5.78.22Q294.55,189.79,295.24,172.06Z",
    style: {
      fill: "#517d9f",
      stroke: "#517d9f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.26,173.15q5-.09,10.05,0c0,.53-.07,1.6-.1,2.13-3.33-.07-6.66-.08-10,0Z",
    style: {
      fill: "#ffb09f",
      stroke: "#ffb09f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.33,172.72c3.72-.15,7.46-.12,11.19.09-.18,12.73-.07,25.46-.07,38.19a90.65,90.65,0,0,1-11.42-.09c.32-6,.19-12,.08-17.95C225.5,186.22,225.41,179.47,225.33,172.72Z",
    style: {
      fill: "#4f81a1",
      stroke: "#4f81a1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,175.23c2.59.21,5.71-.8,8,.62,0,.57,0,1.71,0,2.28a25.91,25.91,0,0,1-8-.33C240.48,177.16,240.53,175.88,240.56,175.23Z",
    style: {
      fill: "#5a3c64",
      stroke: "#5a3c64",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.22,175.29c3.33-.08,6.66-.07,10,0,.87,12.17.17,24.39.4,36.58l-.29-.1a13.07,13.07,0,0,0-7.74-1.23l-2.66-3.95C188,196.16,187.49,185.71,188.22,175.29Z",
    style: {
      fill: "#c0575c",
      stroke: "#c0575c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.82,175.42H214c2.35,0,4.71,0,7.07,0h1.65c-.19,11-.05,22-.15,33-3.25-.06-6.49-.14-9.74-.15C212.83,197.31,212.76,186.37,212.82,175.42Z",
    style: {
      fill: "#dcddda",
      stroke: "#dcddda",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.62,179.31c3.08,0,6.15,0,9.23,0,0,10.62-.07,21.24.07,31.85q-4.71.09-9.44,0C239.75,200.5,239.44,189.9,239.62,179.31Z",
    style: {
      fill: "#7869a3",
      stroke: "#7869a3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,205.22c4.79.15,9.66-.49,14.41.3l-.38,1.68c-4.63.28-9.27,0-13.91.14Z",
    style: {
      fill: "#76554e",
      stroke: "#76554e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.64,205.35c4.79-.21,9.57-.15,14.36-.16l-.08,2.16c-4.67-.06-9.33,0-14-.08C87.86,206.79,87.72,205.83,87.64,205.35Z",
    style: {
      fill: "#73564e",
      stroke: "#73564e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.69,205.8c3.47,0,7.35-.88,10.45,1.15-3.14,1.89-7,1-10.42,1.07C322.29,208.23,322.16,205.55,323.69,205.8Z",
    style: {
      fill: "#8a6c67",
      stroke: "#8a6c67",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.32,205.17c3.58-.33,7.18-.36,10.78-.41,0,.6.11,1.79.15,2.39a101.64,101.64,0,0,1-11,0C338.24,206.62,338.29,205.65,338.32,205.17Z",
    style: {
      fill: "#4d6f8e",
      stroke: "#4d6f8e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,205.72c3.93-1.71,8.49-.54,12.68-.68,0,.55,0,1.65,0,2.21a101.42,101.42,0,0,1-12.08-.13Z",
    style: {
      fill: "#4e718e",
      stroke: "#4e718e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,205.84c5.34.16,10.72-.63,16,0,1.35.43,1.5,1.16.45,2.21-5.29-.23-10.66.37-15.88-.53Z",
    style: {
      fill: "#a56545",
      stroke: "#a56545",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,209a3.2,3.2,0,0,1,3-1.49c4.56,0,9.13.12,13.7,0,0,.52.11,1.57.15,2.09C147.4,209.33,141.68,210.32,136.18,209Z",
    style: {
      fill: "#a1d0ef",
      stroke: "#a1d0ef",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.09,206.57a45.14,45.14,0,0,1,11,.38c0,.42,0,1.28,0,1.71a37.5,37.5,0,0,1-10.94.29C160.16,208.35,160.11,207.16,160.09,206.57Z",
    style: {
      fill: "#b2393b",
      stroke: "#b2393b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.92,206.59l2.66,3.95-2.45.77c3.25,1.34,6.8.81,10.19.46l.29.1c0,.83,0,2.5,0,3.33-3.46.17-6.93.23-10.39.24C188,212.5,187.88,209.54,187.92,206.59Z",
    style: {
      fill: "#ab5a60",
      stroke: "#ab5a60",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.18,207.49c1.93-.07,3.84-.27,5.78-.22l.12.82a22.32,22.32,0,0,1-5.83.12Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.93,208.25c2.29-1.64,5.38-.5,8-.85-.05.48-.16,1.45-.21,1.93l-3.59-.24Z",
    style: {
      fill: "#4f222e",
      stroke: "#4f222e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.85,208.66l.69-.31c2.74,0,5.49.05,8.23,0,0,.68-.05,2-.07,2.71l-9.08-.13C176.67,210.34,176.79,209.22,176.85,208.66Z",
    style: {
      fill: "#ea7e7d",
      stroke: "#ea7e7d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.35,209.29a34.44,34.44,0,0,1,8,.89l.21,0a27.34,27.34,0,0,1-8.23,1.21C202.35,210.9,202.35,209.82,202.35,209.29Z",
    style: {
      fill: "#555667",
      stroke: "#555667",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.77,210c2.43-1.89,5.58-1.38,8.45-1.41v1.48c-2.4,0-4.81.11-7.21,0Z",
    style: {
      fill: "#675f5d",
      stroke: "#675f5d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,209.25c3.23-.09,6.54-.43,9.7.53-2.39,2.74-6.43.91-9.57,1.48C265.66,210.76,265.59,209.75,265.56,209.25Z",
    style: {
      fill: "#855b11",
      stroke: "#855b11",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.13,211.31l2.45-.77a13.07,13.07,0,0,1,7.74,1.23C194.93,212.12,191.38,212.65,188.13,211.31Z",
    style: {
      fill: "#ffa99b",
      stroke: "#ffa99b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.77,210l1.23.1c2.86.26,5.72.43,8.58.54-.05,1.56-.1,3.12-.14,4.68-3.23,0-6.46.12-9.69-.05C212.74,213.52,212.72,211.77,212.77,210Z",
    style: {
      fill: "#dedadd",
      stroke: "#dedadd",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.56,211.91l1.41-1.83a57.86,57.86,0,0,1,6-.15l.76.06c.17.49.52,1.45.69,1.93Q257,212.06,252.56,211.91Z",
    style: {
      fill: "#a5cce8",
      stroke: "#a5cce8",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.4,210.4a24,24,0,0,1,6.53.8c-2.16.23-4.32.34-6.48.41C295.44,211.31,295.41,210.7,295.4,210.4Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,210.9l9.08.13c0,1.41,0,2.83-.07,4.25l-9,.11C176.66,213.89,176.64,212.4,176.62,210.9Z",
    style: {
      fill: "#de6061",
      stroke: "#de6061",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,210.91a90.65,90.65,0,0,0,11.42.09c0,1.39,0,2.78,0,4.18-3.82.14-7.64.14-11.46.13C225,213.84,225,212.37,225,210.91Z",
    style: {
      fill: "#597a9b",
      stroke: "#597a9b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.48,211.1q4.72.14,9.44,0c0,1.36.09,2.71.14,4.07a93.26,93.26,0,0,1-9.75,0C239.37,213.81,239.43,212.45,239.48,211.1Z",
    style: {
      fill: "#7a6c97",
      stroke: "#7a6c97",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65,215.47c4.72-.29,9.45-.06,14.18-.16h2c4.3,0,8.6,0,12.91,0h2.1c5.6,0,11.21.27,16.81-.16l1.26-.11a8.46,8.46,0,0,1,3.33,1.74,32.72,32.72,0,0,1-8,.69c-15.17-.14-30.35.08-45.53-.09C336,216.88,336.42,215.94,336.65,215.47Z",
    style: {
      fill: "#4b1e21",
      stroke: "#4b1e21",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.72,215.49c7.59-.2,15.17-.08,22.76-.13l1.84,2c-8.09,0-16.19.06-24.29,0Z",
    style: {
      fill: "#581406",
      stroke: "#581406",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.37,217.51c1.94,0,3.89-.06,5.84-.12,16.61-.06,33.21,0,49.82,0,8.1.07,16.2,0,24.29,0,7.25.06,14.5,0,21.75,0q22.65,0,45.31,0c20.72,0,41.45.15,62.17-.06q36.58.09,73.17,0c15.18.17,30.36,0,45.53.09a32.72,32.72,0,0,0,8-.69l.5.06c.12,2.75.19,5.5.26,8.25q-144.93,0-289.87,0c-15.65.14-31.3-.28-46.94.14C53.23,222.64,53.31,220.07,53.37,217.51Z",
    style: {
      fill: "#f8976f",
      stroke: "#f8976f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.22,225.22c15.64-.42,31.29,0,46.94-.14q144.93,0,289.87,0c0,.58,0,1.73.05,2.3-2.55-.31-5.11-.51-7.67-.63q-.18,8.13,0,16.26l4.5.46c0,20.67-.1,41.36,0,62l-1.95.06c-.06-20.1,0-40.2,0-60.29-5.17-.1-10.34-.09-15.51,0-.12,20.13,0,40.27-.1,60.4l-.05,1.86-3.08,0c-.09-.53-.26-1.6-.35-2.14s-.26-1.7-.34-2.27,0-1.7,0-2.26c.35-16.58.2-33.16.14-49.73,0-.61,0-1.83,0-2.44.11-3.87,0-7.74-.24-11.6-4.3-.4-8.62-.33-12.94-.44l-1.82-1.41c5.6-.08,11.23-.53,16.83,0,0,2.73,0,5.46,0,8.19,4.27-.14,8.55-.18,12.82,0,.11-5.4,0-10.79.14-16.19-105.69-.26-211.37-.07-317.06-.09q-.06,9,.05,18.09c-1.07.15-2.14.34-3.19.56l-1.42,1.51-.8,1a22.88,22.88,0,0,0-1.14,8.82c-.28-3.42-.9-6.83-.75-10.27.84-2,3.44-1.48,5.1-2.13.29-5.86-.08-11.74.29-17.59l.24-.86C58.93,226.15,55.77,226.86,53.22,225.22Z",
    style: {
      fill: "#521921",
      stroke: "#521921",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.53,227.2c2.67,0,5.34,0,8-.09-.37,5.85,0,11.73-.29,17.59-1.66.65-4.26.17-5.1,2.13-.15,3.44.47,6.85.75,10.27,1.91,23.31,3.21,46.66,5.12,70-2,3.13-5.61,4.49-8.84,6a156.71,156.71,0,0,1,0-16.22c.48-6.65.3-13.32.29-20C53.5,273.66,53.37,250.43,53.53,227.2Z",
    style: {
      fill: "#87453b",
      stroke: "#87453b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.41,227.12c105.69,0,211.37-.17,317.06.09-.13,5.4,0,10.79-.14,16.19-4.27-.15-8.55-.11-12.82,0,0-2.73,0-5.46,0-8.19-5.6-.57-11.23-.12-16.83,0,0,2.48,0,5,0,7.47l-7.09,0c-.17-1.39-.34-2.77-.52-4.14q-9.93,0-19.87,0c-6.22-.13-12.48.47-18.67-.32-7.63-1.65-15.49-.17-23.21-.93-6.17-.39-12.36-.13-18.54-.17-.05.76-.17,2.26-.22,3-7.29.16-14.58,0-21.87.1,0-1.68-.09-3.37-.12-5.05-11.08-1.21-22.27-.2-33.4-.47-5.48,0-11-.52-16.44.43,0,1,.17,3.05.22,4.07-6.56-.27-13.15-.86-19.7,0-4.67-4-11.27-1.48-16.83-2.08-.38,3.27,1.23,7.81-2.32,9.73-4.2,14.92-7.94,30-11.52,45.07-.6-15.7,0-31.41-.29-47.11-.14-.42-.4-1.24-.53-1.65-8.59-.41-17.17.17-25.76.08,0-1,0-3,0-4-5-.26-10-.23-15.05,0,0,2.8,0,5.61,0,8.42-5.39-.07-10.78-.06-16.18,0,0,1.92,0,3.83,0,5.75-1.58.49-3.2.87-4.81,1.29,0-3.49,0-7.07-1.28-10.36-4.44.2-8.89.31-13.3.91Q63.34,236.17,63.41,227.12Z",
    style: {
      fill: "#e4dad9",
      stroke: "#e4dad9",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.41,226.73c2.56.12,5.12.32,7.67.63-.39,12.18-.15,24.36-.21,36.54.19,13.84-.23,27.68.17,41.52-1,0-2.08,0-3.12.07-.14-20.68-.06-41.37,0-62l-4.5-.46Q382.23,234.86,382.41,226.73Z",
    style: {
      fill: "#854541",
      stroke: "#854541",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.69,232.3l1.76,0c2.21,4.33,4.49,8.77,5.1,13.66a23.57,23.57,0,0,1-6.12,18.44c-.08-.34-.25-1-.33-1.34,2-4.56,5.14-8.94,4.89-14.15.37-5.1-2.11-9.69-4.16-14.17C27,239,24.74,244.45,23.29,250c-1,3.86.93,7.61,1.77,11.31l-.55,1.42c-3.76-5.11-3.94-12.19-1.52-17.91C24.47,240.23,27.48,236.46,29.69,232.3Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.29,250c1.45-5.5,3.75-10.91,7.54-15.23,2.05,4.48,4.53,9.07,4.16,14.17.25,5.21-2.89,9.59-4.89,14.15l-1.3-1.33c-.66-5,0-9.95-.08-14.92-1.17,4.82-1,9.8-.95,14.71l-2.71-.24C24.22,257.56,22.26,253.81,23.29,250Z",
    style: {
      fill: "#2c964e",
      stroke: "#2c964e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,235.19c5.43-.95,11-.41,16.44-.43,11.13.27,22.32-.74,33.4.47,0,1.68.07,3.37.12,5.05,7.29-.05,14.58.06,21.87-.1.05-.76.17-2.26.22-3,6.18,0,12.37-.22,18.54.17-.13.43-.4,1.3-.53,1.74-5.44.23-10.89,0-16.33.08.11,30.68,0,61.36,0,92-.68-.81-1.34-1.62-2-2.44,0-1.82,0-3.63.05-5.44,0-.19,0-.59,0-.79q-.06-40.11-.05-80.21c-2.68-.06-5.36-.08-8-.11-.11,10.55,0,21.11-.07,31.66-.71,5.34,4.3,10,1.66,15.33l-2,.16c1.51-3.71.41-7.55-1.25-11-13.52-.24-27-1.13-40.56-.43a199.7,199.7,0,0,0-21.19.19c.6-.83,1.2-1.66,1.81-2.48,5.49-.1,11-.09,16.48,0,0-13.05.59-26.14-.31-39.16-5.4.19-10.8.18-16.2.05-.28,1.06-.55,2.12-.82,3.19l-1.06-.46C190.91,238.24,190.79,236.2,190.74,235.19Z",
    style: {
      fill: "#3c2135",
      stroke: "#3c2135",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.71,235.2l1.82,1.41c.31,23-.14,45.95.17,68.89a131.91,131.91,0,0,0,13.19-.15c.09.54.26,1.61.35,2.14-4.91,0-9.82.05-14.73.12-.15-.57-.47-1.71-.62-2.28-.52-20.21-.06-40.46-.23-60.69,0-.66,0-1.32,0-2C350.72,240.18,350.71,237.68,350.71,235.2Z",
    style: {
      fill: "#4b1e21",
      stroke: "#4b1e21",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.43,237.17c5.56.6,12.16-1.91,16.83,2.08,6.55-.85,13.14-.26,19.7,0l1.06.46c.27-1.07.54-2.13.82-3.19-.06,13,0,26.08,0,39.12-.61.82-1.21,1.65-1.81,2.48-1.52,0-3,0-4.55,0,.4.63.81,1.27,1.23,1.91l1.53,1.48c.11,1,.21,2.07.32,3.11-.05,1.5-.13,3-.23,4.5,17.93.32,35.86,0,53.8.14a27.46,27.46,0,0,1,4.13.38c-19.53-.56-39.09.08-58.63-.33l-.42.64c-.78,1.17-1.54,2.34-2.3,3.53,20.09.27,40.18-.09,60.27.16,1.94-.07,4,.06,5.82-.71a15.87,15.87,0,0,0,2-3.62l2-.16c-.88,2.06-1.82,4.1-2.64,6.18,2.65.06,5.31.08,8,.13a8.17,8.17,0,0,1-3.62,4.95c-1,2.78-2.83,6.1-1,8.95,1.8,2.36,4.07,4.34,5.67,6.87-2.52.5-5.07.8-7.62,1.07.51,1.51.95,3.05,1.59,4.53a60.76,60.76,0,0,0,6.18.65c0,.2,0,.6,0,.79-2.15.39-4.32.67-6.48,1-.07.69-.2,2.06-.26,2.75l-1.47,1.49c2.72.06,5.44.11,8.16.23.65.82,1.31,1.63,2,2.44l1.92.92-2.31,1.4-.27-.05c-1.05-.46-2.1-.91-3.17-1.29-29.45.15-58.93-.23-88.36.2l-1.71.19-1.49-.58c-2.4,2.64-2.07,6.15-1.4,9.39l-.4.48h-1.14a39.63,39.63,0,0,1-.2-9.61c.11-1.05.22-2.1.32-3.15l.08-1.19a24.25,24.25,0,0,1-.14-6.91c1.41,2.22,1.92,4.85,2.66,7.35,2.51-2.43,2.29-5.85,1.92-9l-4.49.76c-1.2,0-2.4,0-3.59,0a77.87,77.87,0,0,0-7.86-1.67c1-8.15.11-16.34.31-24.51-.08-7.14.58-14.35-.68-21.42a36.3,36.3,0,0,0-2.72,7.33c-2,8.09-4.11,16.15-6.39,24.17-1.57,4.57.72,9.18,1.91,13.55H145c-.88-3.34-1.71-6.7-2.46-10.07l-2.17-.29c-.06,3.44,0,6.88,0,10.32h-2.35c.2-4.48,1-9.21-1-13.41.46-1.88.92-3.77,1.29-5.66V298c.11-17.66-.07-35.32.12-53l1.83-.16c.31,15.7-.31,31.41.29,47.11,3.58-15.09,7.32-30.15,11.52-45.07C155.66,245,154.05,240.44,154.43,237.17Z",
    style: {
      fill: "#4f222e",
      stroke: "#4f222e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.84,236.53c5.4.13,10.8.14,16.2-.05.9,13,.29,26.11.31,39.16-5.49-.08-11-.09-16.48,0C192.83,262.61,192.78,249.57,192.84,236.53Z",
    style: {
      fill: "#92c2e5",
      stroke: "#92c2e5",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,237c8.3-.72,16.66-.2,25-.34-.1.43-.29,1.29-.38,1.72a34.64,34.64,0,0,0-1,9.13l-.59-.08c-7.57-1.48-15.37-.4-23-.57Z",
    style: {
      fill: "#4b7894",
      stroke: "#4b7894",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.53,236.61c4.32.11,8.64,0,12.94.44.2,3.86.35,7.73.24,11.6l-1.42.19q-.3-1.83-.57-3.66c-3,0-6,0-9,.06q-.51,1.74-1,3.51c-.16.52-.47,1.57-.62,2.1q6.3.18,12.6.24c.06,16.57.21,33.15-.14,49.73l-1.3-.07c-.26-1.16-.51-2.32-.73-3.48-2.86,0-5.72,0-8.57,0-.47,1.13-.94,2.28-1.39,3.43l-.4,1.19.58.81c3.92.21,7.87.06,11.8.4.08.57.25,1.7.34,2.27a131.91,131.91,0,0,1-13.19.15C352.39,282.56,352.84,259.57,352.53,236.61Z",
    style: {
      fill: "#c55c62",
      stroke: "#c55c62",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.8,239.07c.13-.44.4-1.31.53-1.74,7.72.76,15.58-.72,23.21.93l-1.92,1.32c-6.24-.15-12.48-.21-18.72,0-.1,5.67-.34,11.36.34,17,0,.45,0,1.36,0,1.82-.91,7.46-.26,15-.43,22.47.17,10.83-.24,21.67.2,32.5.12.47.37,1.43.5,1.91,3.93-.09,7.87,0,11.81,0l-1.44-2c-1.54-2.23-3-4.5-4.5-6.77,3.89-1.35,8.05-1,12.1-1,4.74,2.6,10.27,1.89,15.46,2.27l.87,1.61c-8.25-.31-16.49-1.05-24.75-.73a20.41,20.41,0,0,0,2.41,2.23l1,2.37c.42,1.19.82,2.41,1.15,3.65l.13,1.4c0,.35,0,1.05,0,1.4-.09,1.48-.21,3-.36,4.46,7.53.06,15.06,0,22.59.16l-.21.42c-7.49-.35-15-.32-22.49-.15l-.93,1.57c-.81,1.24-1.68,2.43-2.61,3.59a22.63,22.63,0,0,1-4,2.87,36.86,36.86,0,0,0-7.64-.5c-1.21.73-2.43,1.45-3.63,2.21l-2,1.33c-4.36-1.4-9-1.42-13.44-2.18l2.31-1.4,2.3-.66a101.2,101.2,0,0,0,11.94,0c-.07-3.35-.36-6.69-.25-10a60.64,60.64,0,0,0,.2-7.38q-.21-30.71,0-61.42C280.84,248.11,280.68,243.58,280.8,239.07Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36,239.11H167c0,26.13.24,52.27-.15,78.4q-5.09-.18-10.17-.05C156.17,291.35,156.52,265.22,156.36,239.11Z",
    style: {
      fill: "#c9616a",
      stroke: "#c9616a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,247.46a34.64,34.64,0,0,1,1-9.13,20.14,20.14,0,0,1,.6,4.51c0,10.83-.14,21.65-.05,32.48-8.38.5-16.78.15-25.17.22,0-9.39-.2-18.8.25-28.18,7.6.09,15.2-.1,22.8,0Z",
    style: {
      fill: "#497894",
      stroke: "#497894",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.47,239.15c5.44,0,10.89.15,16.33-.08-.12,4.51,0,9-.19,13.55-5,.12-10.06.09-15.09,0,0,.44,0,1.33-.06,1.77l3-.06c.05.54.16,1.62.21,2.16l-2.14,1c-.45,17.11,0,34.25-.21,51.37a30.8,30.8,0,0,0,.88,7.94c-.16,1.48-.32,3-.49,4.45-.08.67-.15,1.34-.2,2-.15,2.45-.17,4.91-.19,7.38l1.61.51.79.25-2.3.66-1.92-.92C264.46,300.51,264.58,269.83,264.47,239.15Z",
    style: {
      fill: "#6498bf",
      stroke: "#6498bf",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.62,239.58l1.92-1.32c6.19.79,12.45.19,18.67.32l.44,1.95c.14,21.7,0,43.4,0,65.11q-1.29,1-2.61,2.07l-.89.08H318c-5.19-.38-10.72.33-15.46-2.27C302.76,283.55,302.49,261.56,302.62,239.58Z",
    style: {
      fill: "#431227",
      stroke: "#431227",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.21,238.58q9.94-.09,19.87,0c.18,1.37.35,2.75.52,4.14l7.09,0c0,.65,0,1.31,0,2l-7-.07c-.17,20.34,0,40.69-.11,61,2.45-.06,4.9-.14,7.35-.28.15.57.47,1.71.62,2.28-6.64,0-13.28-.24-19.91.26l-2.26-.35.92,2.22c-.55-.8-1.1-1.59-1.66-2.37-2.51.08-5,.15-7.53.34q1.32-1,2.61-2.07c5.95-.11,11.91,0,17.87-.14,0-21.65.05-43.3,0-64.94-6-.09-11.92.05-17.88,0Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,239.23c5-.2,10-.23,15.05,0,0,1,0,3,0,4,8.59.09,17.17-.49,25.76-.08.13.41.39,1.23.53,1.65l-1.83.16c-4.23.14-8.45,0-12.68.06-.08,24.11,0,48.22-.12,72.33,4.14,0,8.27,0,12.41,0h2.35l4.59,0h2.26c2.22,0,4.45-.11,6.68-.19,1-14.94-.83-29.92.52-44.86,1.26,7.07.6,14.28.68,21.42-.2,8.17.69,16.36-.31,24.51a77.87,77.87,0,0,1,7.86,1.67c-16.42.25-32.84,0-49.26.21l-.36.88-1.21,3c-4.07-14-7.79-28.06-12.07-42-2-6.3-3.07-12.89-5.46-19.08l-4.65.72c-.14-.53-.43-1.59-.58-2.12,2.9-.39,6-1,8.63.72a63.41,63.41,0,0,0,.84,8.59c-.16-6.85.42-13.69.11-20.54l-2.26-.5c-3.84-.72-7.78-.32-11.65-.1-.12.57-.35,1.69-.46,2.25l-1.48,1.29c0-1.92,0-3.83,0-5.75,5.4,0,10.79,0,16.18,0C99,244.84,99,242,99,239.23Z",
    style: {
      fill: "#381f33",
      stroke: "#381f33",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9,239.57c6.24-.2,12.48-.14,18.72,0-.13,22,.14,44-.12,65.95-4.05-.07-8.21-.39-12.1,1,1.48,2.27,3,4.54,4.5,6.77-3.63,0-7.25.15-10.87.12-.44-10.83,0-21.67-.2-32.5.17-7.49-.48-15,.43-22.47,4.67-.1,9.35,0,14-.06a2.72,2.72,0,0,0,2.77-1.31c-5.56-.86-11.22-.18-16.82-.45C283.56,250.93,283.8,245.24,283.9,239.57Z",
    style: {
      fill: "#746ca7",
      stroke: "#746ca7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,241.08c3.66,0,7.33,0,11,0-.11,21.27,0,42.54-.06,63.82a91,91,0,0,1-.3,11.44c-1.47-4.59-2.42-9.33-4-13.89l2.46-.19c0-.48-.08-1.43-.1-1.91l-3,0c-1.36-6.06-3.22-12-5.13-17.89-1.17-5.41-.84-11-.87-16.48C101.15,257.66,100.81,249.37,101,241.08Z",
    style: {
      fill: "#e5e6f0",
      stroke: "#e5e6f0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.34,240.55c2.3.31,1.63,2.74,1.76,4.4-.47,23.84.4,47.72-.32,71.55l-1.65,1c-.42-21.83,0-43.68-.15-65.51C168.92,248.14,169,244.34,169.34,240.55Z",
    style: {
      fill: "#694963",
      stroke: "#694963",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,241.13c5.75-.3,11.51-.63,17.23.15,0,11.44,0,22.88,0,34.33-2.27,0-4.55,0-6.81.19-1.37,3.07,2.39,4.75,3.82,7,.58,3.8-1.2,7.2-4.06,9.59-.12.7-.35,2.1-.47,2.8-3.28.18-6.76-.21-9.74,1.46C173.58,278.12,173.61,259.62,173.49,241.13Z",
    style: {
      fill: "#ec6260",
      stroke: "#ec6260",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.56,305.49c.12-21.66-.25-43.32.16-65l15.84,0c.52,21.66,0,43.34.21,65C316.37,305.61,311,305.61,305.56,305.49Z",
    style: {
      fill: "#dc7074",
      stroke: "#dc7074",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.65,240.53c6,.08,11.92-.06,17.88,0,.07,21.64,0,43.29,0,64.94-6,.16-11.92,0-17.87.14C323.62,283.93,323.79,262.23,323.65,240.53Z",
    style: {
      fill: "#b2bfd9",
      stroke: "#b2bfd9",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,242.21c4,0,7.92,0,11.87,0-.34,11.16,0,22.33-.21,33.5-3.9-.06-7.81-.09-11.71-.07-.07-6.38.06-12.77-.05-19.15,3.44.07,6.87.1,10.32.14.13-1.53.28-3.05.42-4.56-3.58-.08-7.16-.1-10.73,0C240.72,248.8,240.7,245.5,240.74,242.21Z",
    style: {
      fill: "#fef3eb",
      stroke: "#fef3eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.46,242.2c2.68,0,5.36.05,8,.11q0,40.11.05,80.21a60.76,60.76,0,0,1-6.18-.65c-.64-1.48-1.08-3-1.59-4.53,2.55-.27,5.1-.57,7.62-1.07-1.6-2.53-3.87-4.51-5.67-6.87-1.8-2.85,0-6.17,1-8.95a8.17,8.17,0,0,0,3.62-4.95c-2.66-.05-5.32-.07-8-.13.82-2.08,1.76-4.12,2.64-6.18,2.64-5.29-2.37-10-1.66-15.33C254.48,263.31,254.35,252.75,254.46,242.2Z",
    style: {
      fill: "#fdf3eb",
      stroke: "#fdf3eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.32,242.2c3.87-.09,7.79-.78,11.64-.08,2.64,2.54,1.33,6.81,1.23,10.06q-6.26-.09-12.52-.06C307,248.86,306.14,245.45,307.32,242.2Z",
    style: {
      fill: "#ec605d",
      stroke: "#ec605d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.32,242.09c3.85,0,7.74-.43,11.57.21a3.47,3.47,0,0,1,2.23,2.71c.16,19.57.79,39.19-.16,58.76a65.11,65.11,0,0,1-14.7.16c-.47-14.31-.09-28.65-.36-43,.11-2-.44-4.52,1.67-5.68,4.11-.26,8.24-.1,12.36-.05,0-1.89,0-3.78,0-5.66-4.06.1-8.12,0-12.18.1-.05.39-.14,1.18-.18,1.57C323.71,249,325.28,244.91,326.32,242.09Z",
    style: {
      fill: "#90c2e7",
      stroke: "#90c2e7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.46,245.21c4.41-.6,8.86-.71,13.3-.91,1.33,3.29,1.27,6.87,1.28,10.36,1.61-.42,3.23-.8,4.81-1.29l1.48-1.29c2.81,1.59,3.67,4.68,4.28,7.62l.51,2c.15.53.44,1.59.58,2.12a173,173,0,0,0,5.19,19.38q7,25.3,13.81,50.66L114,332c-.71-2.64-1.4-5.28-2.1-7.91l1.21-3a60.82,60.82,0,0,0,2.2,7.73l1.3.12c16.56.31,33.12.16,49.68.11-.1,1.05-.21,2.1-.32,3.15-12.25.47-24.52-.07-36.78.14-4.32.18-8.79-.76-13,.53-1.15.61-2.27,1.26-3.36,2,5,.32,10.18-.89,15.09.71-7.08.62-14.56,1.48-21.32-1.26a120.63,120.63,0,0,1-2.74-11.83c-6.28.81-12.33,2.79-18.45,4.36-.34-.68-.68-1.36-1-2,5.44-3.15,12.21-2.89,17.36-6.56a19.45,19.45,0,0,0-.77-5.42C97.86,302,95,291,91.86,280.16c-.31-1-.64-2.06-1-3.08-5.74,1.33-11.5,2.64-17.16,4.29.72,2.55,1.44,5.11,2.13,7.68,1.92,7.74,4.52,15.3,6.18,23.12-.18,2.06-.44,4.13-.56,6.21a17.65,17.65,0,0,0,.68,7.57v.36c-.13,3-.12,6.08-.12,9.12-5.1,1-10.37.29-15.39,1.7l-1.17.12c-.92-.84-1.85-1.67-2.77-2.49-.14-1.3-.26-2.59-.38-3.88s-.21-2.54-.3-3.8c-1.91-23.32-3.21-46.67-5.12-70a22.88,22.88,0,0,1,1.14-8.82c2.9,28.68,3.88,57.54,6.61,86.23,5.32-.12,10.64-.09,16-.16-1.81-10.79.22-22-3.22-32.55C74,290.35,71.25,278.73,68,267.25a63.69,63.69,0,0,1-1.49-7.37c0-.56,0-1.68-.05-2.25l9.33-2.4a83.62,83.62,0,0,0-.53-8.52c-5.45-.74-10.93.72-16.41.57l1.42-1.51C61.32,245.55,62.39,245.36,63.46,245.21Z",
    style: {
      fill: "#402433",
      stroke: "#402433",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46,245.35a64.28,64.28,0,0,1,9.31-.07c-.12,24,0,48.1,0,72.15-3.3.06-6.59.05-9.88-.11.2-15.83,0-31.65.1-47.47.08-5.23-.3-10.48.36-15.69a38,38,0,0,0,9.33-.94c-3-1.08-6.17-.76-9.26-.84C114.37,250.12,113.27,247.34,114.46,245.35Z",
    style: {
      fill: "#5882a4",
      stroke: "#5882a4",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.79,245.08c4.23,0,8.45.08,12.68-.06-.19,17.66,0,35.32-.12,53a39.93,39.93,0,0,0-10.86-.62l.49,1.84a51.5,51.5,0,0,0,10.37-.85c-.37,1.89-.83,3.78-1.29,5.66,2,4.2,1.22,8.93,1,13.41-4.14-.06-8.27,0-12.41,0C125.8,293.3,125.71,269.19,125.79,245.08Z",
    style: {
      fill: "#dddddb",
      stroke: "#dddddb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.37,245.27h11.47l-.15,4.9a83.28,83.28,0,0,0-11.17,0C195.47,248.57,195.41,246.92,195.37,245.27Z",
    style: {
      fill: "#40647d",
      stroke: "#40647d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.54,305.61c.07-20.35-.06-40.7.11-61l7,.07c.17,20.23-.29,40.48.23,60.69C348.44,305.47,346,305.55,343.54,305.61Z",
    style: {
      fill: "#9fc2e0",
      stroke: "#9fc2e0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.74,245.24c3-.05,6-.06,9-.06q.27,1.83.57,3.66a53.33,53.33,0,0,1-10.57-.09Q354.23,247,354.74,245.24Z",
    style: {
      fill: "#8d353b",
      stroke: "#8d353b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.47,245.25c5.17-.08,10.34-.09,15.51,0,0,20.09-.07,40.19,0,60.29-5.2.12-10.4.05-15.6.1C369.5,285.52,369.35,265.38,369.47,245.25Z",
    style: {
      fill: "#f3c3ab",
      stroke: "#f3c3ab",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.28,247.05c1-.38,2-.75,3.07-1.11a23.12,23.12,0,0,1,.73,5c0,17.56.14,35.12-.24,52.68l-3.31.14Q344.69,275.4,345.28,247.05Z",
    style: {
      fill: "#85bbdf",
      stroke: "#85bbdf",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.77,261.5c0-4.91-.22-9.89.95-14.71.07,5-.58,10,.08,14.92L30.1,263c.08.33.25,1,.33,1.34-2.87,3.22-.85,7.64-1,11.47,0,6-.06,12.06,0,18.09.34-.95.72-1.87,1.14-2.77,1.25-.59,2.52-1.11,3.79-1.66l-1.81,1.21a41.1,41.1,0,0,0,.51,17.86l5.58-.21a50.86,50.86,0,0,1-10,1.75,27.75,27.75,0,0,0-4.52-11.48c.3-.49.88-1.47,1.18-1.95a11.63,11.63,0,0,0,2.26,2.79c-.55-6.75-4.8-12.47-8.25-18.08-1.94-.42-3.88-.84-5.82-1.23l.07-.45c2.38.39,5.16,1.48,7.26-.26,2.24,3.48,4.29,7.06,6.55,10.52-.19-8.17-.64-16.33-.76-24.5a15.93,15.93,0,0,1-2.15-2.8l.55-1.42Z",
    style: {
      fill: "#451f2b",
      stroke: "#451f2b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.05,248.28l.8-1c5.48.15,11-1.31,16.41-.57a83.62,83.62,0,0,1,.53,8.52l-9.33,2.4c0,.57,0,1.69.05,2.25l0,2.34-4.89.19c.07,1.68.15,3.36.22,5l6.12-.21c3.25,11.48,6,23.1,9.4,34.55,3.44,10.53,1.41,21.76,3.22,32.55-5.32.07-10.64,0-16,.16C61.93,305.82,61,277,58.05,248.28Z",
    style: {
      fill: "#91c1e4",
      stroke: "#91c1e4",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85,247.63c2.59.39,5.93-1,8,1.05,0,.61-.14,1.84-.19,2.45-2.62.56-5.33.22-8,.3C102.7,250.16,102.77,248.9,102.85,247.63Z",
    style: {
      fill: "#59656d",
      stroke: "#59656d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.11,249c4.22-2.12,9.38-1.39,13.89-.68l.28,1.21C274.6,250,269.63,250.59,265.11,249Z",
    style: {
      fill: "#c5e3fa",
      stroke: "#c5e3fa",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.74,249.66c4.06-.1,8.12,0,12.18-.1,0,1.88,0,3.77,0,5.66-4.12-.05-8.25-.21-12.36.05,0-1.35-.08-2.7,0-4C326.6,250.84,326.69,250.05,326.74,249.66Z",
    style: {
      fill: "#44677e",
      stroke: "#44677e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.1,250.85c.15-.53.46-1.58.62-2.1a53.33,53.33,0,0,0,10.57.09l1.42-.19c0,.61,0,1.83,0,2.44Q359.4,251,353.1,250.85Z",
    style: {
      fill: "#e19291",
      stroke: "#e19291",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.79,249.83c3.87-.22,7.81-.62,11.65.1,3.7,1.85,1.77,6.66,2.19,10a83.75,83.75,0,0,1-10-.19c-.61-2.94-1.47-6-4.28-7.62C84.44,251.52,84.67,250.4,84.79,249.83Z",
    style: {
      fill: "#5381a3",
      stroke: "#5381a3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.44,249.93l2.26.5c.31,6.85-.27,13.69-.11,20.54a63.41,63.41,0,0,1-.84-8.59c-2.62-1.7-5.73-1.11-8.63-.72l-.51-2a83.75,83.75,0,0,0,10,.19C98.21,256.59,100.14,251.78,96.44,249.93Z",
    style: {
      fill: "#e5e4f1",
      stroke: "#e5e4f1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.29,250.18c3.85,0,7.7,0,11.55.14,0,1.17,0,2.35.05,3.53a51.92,51.92,0,0,1-10.72.1C286.41,253.31,287.2,251.54,287.29,250.18Z",
    style: {
      fill: "#572f4e",
      stroke: "#572f4e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.37,252.38c3.09.08,6.3-.24,9.26.84a38,38,0,0,1-9.33.94C114.32,253.72,114.35,252.83,114.37,252.38Z",
    style: {
      fill: "#f9f6f7",
      stroke: "#f9f6f7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.64,252.16c3,0,6,0,9,.07,0,1.08,0,2.16,0,3.25a65.49,65.49,0,0,1-8.86-.16C127.75,254.53,127.68,253,127.64,252.16Z",
    style: {
      fill: "#575e61",
      stroke: "#575e61",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,252.59c0-2,3.2-.58,2,.85Z",
    style: {
      fill: "#d9a9a2",
      stroke: "#d9a9a2",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.65,252.09c3.57-.07,7.15-.05,10.73,0-.14,1.51-.29,3-.42,4.56-3.45,0-6.88-.07-10.32-.14C240.62,255.06,240.62,253.57,240.65,252.09Z",
    style: {
      fill: "#865c4e",
      stroke: "#865c4e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.52,252.6c5,.11,10.06.14,15.09,0q-.23,30.7,0,61.42c-1.06-19.91.06-39.88-.57-59.81-3.86,0-7.72,0-11.58.08l-3,.06C265.48,253.93,265.51,253,265.52,252.6Z",
    style: {
      fill: "#cef3ff",
      stroke: "#cef3ff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67,252.12q6.25,0,12.52.06c-.1,1.27-.19,2.55-.26,3.82a75.89,75.89,0,0,1-12.06.24C307.8,254.86,307.74,253.49,307.67,252.12Z",
    style: {
      fill: "#923135",
      stroke: "#923135",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,252.59l2,.85c.26,4.73.16,9.57-1.61,14-2.77,10.08-4.92,20.33-7.65,30.42-1.32-.51-4.19.3-4.14-1.82,3.21-10.24,5.68-20.7,8.18-31.14C150.1,260.78,151.74,256.81,152.4,252.59Z",
    style: {
      fill: "#ca7d60",
      stroke: "#ca7d60",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.52,253.34c3.77.12,7.54.11,11.31,0q0,2.55,0,5.1c-3.77-.15-7.54-.16-11.31,0Z",
    style: {
      fill: "#885744",
      stroke: "#885744",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.49,259.19c5.57-1.32,11.08-2.85,16.66-4.13,1.33,5.12,2.53,10.27,4.11,15.32-5.71,1.39-11.47,2.63-17.09,4.35C70.7,269.62,68.73,264.54,68.49,259.19Z",
    style: {
      fill: "#f9986f",
      stroke: "#f9986f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.94,255.86c1.12-1,2.86-.35,4.22-.47,1.47.16,3.48-.5,4.34,1.13C120.77,256.21,117,257.86,114.94,255.86Z",
    style: {
      fill: "#e5e4f1",
      stroke: "#e5e4f1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.44,254.31c3.86-.07,7.72-.07,11.58-.08.63,19.93-.49,39.9.57,59.81a60.64,60.64,0,0,1-.2,7.38l-2.61,0c-.06-1.55-.11-3.1-.17-4.65-3.48-.06-7,0-10.43.1a30.8,30.8,0,0,1-.88-7.94c.18-17.12-.24-34.26.21-51.37l2.14-1C268.6,255.93,268.49,254.85,268.44,254.31Z",
    style: {
      fill: "#619ac5",
      stroke: "#619ac5",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.8,256.29c.69,0,1.38-.06,2.08-.06C.21,258.1,2.2,262.29,2,265.1A28,28,0,0,1,.8,256.29Z",
    style: {
      fill: "#a7a4a2",
      stroke: "#a7a4a2",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,256.62c5-.47,9.94,0,14.91-.13l-.89,2c-4.85,0-9.71.1-14.56-.18C174.6,257.92,174.87,257.06,175,256.62Z",
    style: {
      fill: "#ffc1bb",
      stroke: "#ffc1bb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.24,256.59c5.6.27,11.26-.41,16.82.45a2.72,2.72,0,0,1-2.77,1.31c-4.68.09-9.36,0-14,.06C284.25,258,284.24,257,284.24,256.59Z",
    style: {
      fill: "#efe5ff",
      stroke: "#efe5ff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,265.1c.23-2.81-1.76-7,.91-8.87,6.22,3.76,13.35,7.4,16.32,14.5,1,2.68,3.4,6,1.67,8.73-2.1,1.74-4.88.65-7.26.26C7.17,277.88,3,271.47,2,265.1Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,258.74c.28-2.18,2.6-1.87,4.24-2.06a50.14,50.14,0,0,1,10.88.43c0,.39.13,1.18.18,1.57A130.17,130.17,0,0,1,306,258.74Z",
    style: {
      fill: "#ffa9a7",
      stroke: "#ffa9a7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.86,258.55a27.35,27.35,0,0,1,6.07-.38c.6,15.11-.56,30.29.66,45.37a31.21,31.21,0,0,1-.8,3.67c-1.89,0-3.77,0-5.65.05-1.24-4.35-.62-8.89-.68-13.34,0-8.35,0-16.7,0-25C115.55,265.44,115.07,261.93,115.86,258.55Z",
    style: {
      fill: "#5388ad",
      stroke: "#5388ad",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25,258.84c8.48,3.3,16.38,10.7,16.41,20.37-.87-.67-1.72-1.34-2.57-2l-1.86,1.31C6.89,276,2.46,267.12,3.25,258.84Z",
    style: {
      fill: "#2b904c",
      stroke: "#2b904c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.51,259.88A63.69,63.69,0,0,0,68,267.25l-6.12.21c-.07-1.69-.15-3.37-.22-5l4.89-.19Z",
    style: {
      fill: "#44607a",
      stroke: "#44607a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.48,261.17c3.47-.88,7.16-.68,10.71-.46,1.7.75,1.24,2.77,1.36,4.24-.1,11.33,0,22.67-.06,34-.14,1.82,0,4.49-2.25,5.09-3.48.24-7.12.36-10.48-.69-1-2-.69-4.32-.77-6.47.13-10.67-.09-21.34.1-32C307.37,263.67,307,261.65,308.48,261.17Z",
    style: {
      fill: "#ed605d",
      stroke: "#ed605d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,263.78l4.65-.72c2.39,6.19,3.41,12.78,5.46,19.08,4.28,13.93,8,28,12.07,42,.7,2.63,1.39,5.27,2.1,7.91l-5.28,1.78q-6.84-25.35-13.81-50.66A173,173,0,0,1,89.7,263.78Z",
    style: {
      fill: "#4b6f85",
      stroke: "#4b6f85",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,263.48c5-.35,10.05-.11,15.07-.24l-.12,1.07q-5.39-.09-10.77,0C176.79,264.21,175.2,264.46,174,263.48Z",
    style: {
      fill: "#fff3ee",
      stroke: "#fff3ee",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.77,269.09c1.27-.48,2.57-.86,3.87-1.24-.79,5.34.23,11.91-3.78,16.09l-1.43.87c-.28.76-.54,1.54-.77,2.33-1.41.8-2.82,1.6-4.25,2.37-1.27.55-2.54,1.07-3.79,1.66,0-7.14.75-16.05,8-19.69l1.41-.84Z",
    style: {
      fill: "#66311a",
      stroke: "#66311a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.78,288.07a16.79,16.79,0,0,1,9.09-17C43.32,277.47,39.9,286.48,32.78,288.07Z",
    style: {
      fill: "#299a53",
      stroke: "#299a53",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.17,274.73c5.62-1.72,11.38-3,17.09-4.35l.51,1.75C84,273.56,78.29,275,72.6,276.62,72.49,276.14,72.28,275.2,72.17,274.73Z",
    style: {
      fill: "#fff3eb",
      stroke: "#fff3eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.76,279.77a36.3,36.3,0,0,1,2.72-7.33c-1.35,14.94.46,29.92-.52,44.86-2.23.08-4.46.17-6.68.19-1.19-4.37-3.48-9-1.91-13.55C147.65,295.92,149.75,287.86,151.76,279.77Z",
    style: {
      fill: "#49738b",
      stroke: "#49738b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.73,281.37c5.66-1.65,11.42-3,17.16-4.29.33,1,.66,2,1,3.08-5.68-1.53-11.25,1.36-16.53,3.15.16,1.91.31,3.83.53,5.74C75.17,286.48,74.45,283.92,73.73,281.37Z",
    style: {
      fill: "#f3c3ab",
      stroke: "#f3c3ab",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.51,278.16c1.51,0,3,0,4.55,0a199.7,199.7,0,0,1,21.19-.19c13.52-.7,27,.19,40.56.43,1.66,3.43,2.76,7.27,1.25,11a15.87,15.87,0,0,1-2,3.62c-1.83.77-3.88.64-5.82.71-20.09-.25-40.18.11-60.27-.16.76-1.19,1.52-2.36,2.3-3.53l-.32,1.61c19.11-.33,38.22-.05,57.34-.14a14.74,14.74,0,0,0,4.65-.79,27.12,27.12,0,0,0,1.65-5.92c-.32-1.44-.69-2.86-1.1-4.27a13.91,13.91,0,0,0-4.19-.72c-14.36.05-28.73-.05-43.09,0-5.15.11-10.33-.58-15.44.28C187.32,279.43,186.91,278.79,186.51,278.16Z",
    style: {
      fill: "#6f7790",
      stroke: "#6f7790",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.33,283.31c5.28-1.79,10.85-4.68,16.53-3.15,3.09,10.88,6,21.81,9.08,32.69a19.45,19.45,0,0,1,.77,5.42c-5.79.75-11.32,2.7-17,4.07-.83-3.41-1.77-6.79-2.7-10.17-1.66-7.82-4.26-15.38-6.18-23.12C75.64,287.14,75.49,285.22,75.33,283.31Z",
    style: {
      fill: "#fb986f",
      stroke: "#fb986f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.74,280.07c5.11-.86,10.29-.17,15.44-.28,14.36-.08,28.73,0,43.09,0a13.91,13.91,0,0,1,4.19.72c0,.84,0,2.52,0,3.36-20.21-.14-40.45.47-60.65-.28a28.29,28.29,0,0,1,5.35-.69q27.32,0,54.65,0l.07-1.43c-20.2-.11-40.41-.14-60.62.07Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46,280.48c.41,1.41.78,2.83,1.1,4.27-20.65,0-41.32.29-62-.09-.11-1-.21-2.08-.32-3.11,20.21-.21,40.42-.18,60.62-.07l-.07,1.43q-27.33,0-54.65,0a28.29,28.29,0,0,0-5.35.69c20.2.75,40.44.14,60.65.28C250.47,283,250.47,281.32,250.46,280.48Z",
    style: {
      fill: "#b9b4b7",
      stroke: "#b9b4b7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.2,284.25c5.31-.54,10.89-.28,15.82,1.93,4.41,2.05,7.42,6.16,9.33,10.51-.3.48-.88,1.46-1.18,1.95-5.17.19-10.72-.21-14.92-3.59A40.47,40.47,0,0,1,.2,284.25Z",
    style: {
      fill: "#39543e",
      stroke: "#39543e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43,284.81l1.43-.87c-.29,7.86-.17,15.73-.18,23.6q3.41-.26,6.82-.44c1.68,9,3.24,18,3.23,27.12.24-5.39.16-10.79.34-16.18l2.07-1.17a156.71,156.71,0,0,0,0,16.22c3.23-1.52,6.81-2.88,8.84-6,.09,1.26.19,2.53.3,3.8A60,60,0,0,0,52,336.52a42.53,42.53,0,0,0,10.73-1.76c.92.82,1.85,1.65,2.77,2.49-3.2.32-6.41.44-9.62.7l-1.45.36-2.35,1.12-2,.1a25.29,25.29,0,0,1-1.2,6c-5.41,1.77-11.24,2.1-16.86,3q-1.3-2.29-2.63-4.57c-5.12,2.81-10.38,5.38-15.3,8.54h1.51a34,34,0,0,0-5.83,2.23,11.54,11.54,0,0,0,.87,4.33l1.38.43.12,1.81-3.47.21c0-2.95,0-5.89.13-8.83,6.62-3.07,12.65-7.27,19.29-10.29-.85-3.56-2.84-6.7-4.08-10.12-1.37-3.19-1.71-6.66-2.43-10-.8-3.78-2.06-7.53-1.88-11.45,3-.3,6-.64,9-.72a50.86,50.86,0,0,0,10-1.75c0-7.08-.06-14.16,0-21.23C38.89,286.35,39.15,285.57,39.43,284.81Z",
    style: {
      fill: "#531c1b",
      stroke: "#531c1b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.59,284.66c20.65.38,41.32,0,62,.09a27.12,27.12,0,0,1-1.65,5.92l-2.62-1a27.46,27.46,0,0,0-4.13-.38c-17.94-.09-35.87.18-53.8-.14C189.46,287.66,189.54,286.16,189.59,284.66Z",
    style: {
      fill: "#d9d1d2",
      stroke: "#d9d1d2",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1,286.26c3.84.06,8.05,0,11.3,2.38l-3.08.9c2.78,1.58,5.7,3,8.14,5.06-1.57.27-3.13.61-4.69.89C10.52,295.12,7.21,290,4.1,286.26Z",
    style: {
      fill: "#2d9656",
      stroke: "#2d9656",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.24,290l.42-.64c19.54.41,39.1-.23,58.63.33l2.62,1a14.74,14.74,0,0,1-4.65.79c-19.12.09-38.23-.19-57.34.14Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.77,295.49c1.56-.28,3.12-.62,4.69-.89a2.59,2.59,0,0,1,1.9,2.24A24.69,24.69,0,0,1,15.77,295.49Z",
    style: {
      fill: "#51865e",
      stroke: "#51865e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.49,297.38a39.93,39.93,0,0,1,10.86.62v.37a51.5,51.5,0,0,1-10.37.85Z",
    style: {
      fill: "#646465",
      stroke: "#646465",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,298.49c1.52-1.69,4.08-1,6.09-1.36q30.57.11,61.15,0a33.4,33.4,0,0,1,4.23.38l-.69,0c-2,0-3.91,0-5.87,0-1.82,5.79-1.09,11.87.11,17.71-18.6.07-37.2,0-55.8,0a41,41,0,0,1-2.21-8.41c-.21-3,1.06-5.79,1.9-8.59l-.8-.52c-1.87-.63-2.11,1.44-2.51,2.75-1.23,4.86-.27,9.88.6,14.71-2-.14-3.91-.41-5.85-.67A18.3,18.3,0,0,1,175,298.49Z",
    style: {
      fill: "#f69a73",
      stroke: "#f69a73",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,297.25c2.85,0,5.71,0,8.57,0,.22,1.16.47,2.32.73,3.48-3.56-.08-7.13-.17-10.69-.07C354,299.53,354.49,298.38,355,297.25Z",
    style: {
      fill: "#8c343b",
      stroke: "#8c343b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6,300.51c.4-1.31.64-3.38,2.51-2.75l.8.52c-.84,2.8-2.11,5.59-1.9,8.59a41,41,0,0,0,2.21,8.41l-3-.06C180.33,310.39,179.37,305.37,180.6,300.51Z",
    style: {
      fill: "#fcc8ab",
      stroke: "#fcc8ab",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.91,297.56c2,0,3.91,0,5.87,0-3.57,5.51-2.77,12.71.95,17.93-2.24-.11-4.47-.18-6.71-.19C238.82,309.43,238.09,303.35,239.91,297.56Z",
    style: {
      fill: "#eeb094",
      stroke: "#eeb094",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.33,298.13q4.83,0,9.64.23c-.08.43-.25,1.29-.33,1.73l-1.15-.09c-2.69-.2-5.38-.51-8.07-.6C247.4,299.08,247.35,298.44,247.33,298.13Z",
    style: {
      fill: "#b19ca3",
      stroke: "#b19ca3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.49,299.06c15.89-.13,31.78,0,47.68-.14,1.58.18,3.71-.38,4.7,1.25a81.77,81.77,0,0,0,.13,12.52c-16.57.29-33.15.08-49.72.11-1.11-.27-3.25.39-3.52-1.19C183.51,307.45,183.39,303,185.49,299.06Z",
    style: {
      fill: "#fc986e",
      stroke: "#fc986e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.08,299.43l4.21.77c-.4,1.51-.79,3-1.2,4.52l-3.93-.08Q139.61,302,140.08,299.43Z",
    style: {
      fill: "#c97f67",
      stroke: "#c97f67",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46,302.14l2-2.74c2.69.09,5.38.4,8.07.6-.41,1.44-.81,2.89-1.18,4.34-3-.09-6-.15-9-.18l0-1.62c3,0,6,.08,9-.09C251.37,302.19,248.41,302.24,245.46,302.14Z",
    style: {
      fill: "#f9f6f7",
      stroke: "#f9f6f7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.17,301.87l.4-1.19c3.56-.1,7.13,0,10.69.07l1.3.07c0,.56,0,1.69,0,2.26-3.93-.34-7.88-.19-11.8-.4Z",
    style: {
      fill: "#dd8788",
      stroke: "#dd8788",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.39,304.66a57.7,57.7,0,0,1,10.18.19l-.95.71a37.94,37.94,0,0,1-8.25.15Z",
    style: {
      fill: "#f1e7e9",
      stroke: "#f1e7e9",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.37,305.71a37.94,37.94,0,0,0,8.25-.15,20,20,0,0,0,3.46,7.63c-3.41-.11-6.95.44-10.23-.73A21,21,0,0,1,245.37,305.71Z",
    style: {
      fill: "#dacfd5",
      stroke: "#dacfd5",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.63,306.1c1.45-.18,3.22-1,4.52,0a21.79,21.79,0,0,1,.31,26.51c2.34,0,4.69-.05,7-.06l-.72,3.57-2.52,1.44-.71-1.7-.13-.3c-27.07.41-54.15,0-81.23.18-8.48-.19-17,.31-25.44-.48a52.7,52.7,0,0,1,3.61,4.14c-.48.87-.95,1.74-1.41,2.62-.91-2.66-2.86-4.68-4.73-6.68a49,49,0,0,0-12.71,4.26c.17.53.51,1.57.69,2.1l-.84,2.7c-2.65-4.81-7.78-7.24-12.83-8.72l2-1.33a72.26,72.26,0,0,1,8.72,4.23,69.27,69.27,0,0,1,12.9-5.18,65.78,65.78,0,0,1-8.88-.1l-1.47-.66a22.63,22.63,0,0,0,4-2.87c7.75,1,15.61.19,23.41.43q.75-1.6,1.53-3.18c.27-.57.82-1.7,1.09-2.26l.21-.42.56-1.14a17.65,17.65,0,0,0-1.16-10.31c-.52-1.18-1.05-2.35-1.62-3.49L318,307.8h2.22c2.41,4.23,3.9,9.15,3.28,14-.36,3.66-2.07,7-3.6,10.24,2.89.07,5.78.15,8.68.27l1.62-2.29c-.21.54-.62,1.61-.82,2.15l2.07-.35c17.25.71,34.53.17,51.79.34,4.38,0,8.77.17,13.14-.2l1.57-.12c3.2-.11,6.79,1.1,9.74-.52a19.13,19.13,0,0,0,.37-23.28c-3.14-.82-6.43-.37-9.63-.36C400.47,307.17,402.54,306.61,404.63,306.1Z",
    style: {
      fill: "#42273c",
      stroke: "#42273c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.57,307.27h.57c1.88,0,3.76,0,5.65-.05,0,.61.16,1.84.22,2.45l-5.94-.08h-.45C115.6,309,115.58,307.84,115.57,307.27Z",
    style: {
      fill: "#2a4d69",
      stroke: "#2a4d69",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.39,307.13l2.17.29c.75,3.37,1.58,6.73,2.46,10.07l-4.59,0C140.35,314,140.33,310.57,140.39,307.13Z",
    style: {
      fill: "#eda28d",
      stroke: "#eda28d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.6,307.87c6.63-.5,13.27-.22,19.91-.26,4.91-.07,9.82-.1,14.73-.12l3.08,0c9.64.2,19.28-.27,28.92.25l-1.62.5a28.3,28.3,0,0,1-.28,23.74c-4.37.37-8.76.22-13.14.2-17.26-.17-34.54.37-51.79-.34A29.89,29.89,0,0,0,331.6,307.87Z",
    style: {
      fill: "#736ba7",
      stroke: "#736ba7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.56,308.46q4.23.06,8.49,0l-.12,1.84q-4-.09-8-.09C127.87,309.76,127.66,308.89,127.56,308.46Z",
    style: {
      fill: "#676968",
      stroke: "#676968",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.18,307.79l.89-.08c2.5-.19,5-.26,7.53-.34.56.78,1.11,1.57,1.66,2.37,3.1,6.33,2.78,14-.1,20.32l-1.62,2.29c-2.9-.12-5.79-.2-8.68-.27,1.53-3.28,3.24-6.58,3.6-10.24C324.08,316.94,322.59,312,320.18,307.79Z",
    style: {
      fill: "#7169a2",
      stroke: "#7169a2",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.34,307.52l2.26.35a29.89,29.89,0,0,1-.19,24l-2.07.35c.2-.54.61-1.61.82-2.15,2.88-6.35,3.2-14,.1-20.32Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,308.26l1.62-.5.15,0c3.23,7.71,3.42,16.66-.48,24.16l-1.57.12A28.3,28.3,0,0,0,396.62,308.26Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.39,307.72c3.2,0,6.49-.46,9.63.36a19.13,19.13,0,0,1-.37,23.28c-2.95,1.62-6.54.41-9.74.52C401.81,324.38,401.62,315.43,398.39,307.72Z",
    style: {
      fill: "#746ca6",
      stroke: "#746ca6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08,308.68c8.26-.32,16.5.42,24.75.73-2.59,1.69-5.76,1.18-8.67,1.18a115.45,115.45,0,0,0-13.67.32A20.41,20.41,0,0,1,294.08,308.68Z",
    style: {
      fill: "#f9f6f7",
      stroke: "#f9f6f7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.83,309.41c.57,1.14,1.1,2.31,1.62,3.49-7.65.11-15.31-.25-22.94.38l-1-2.37a115.45,115.45,0,0,1,13.67-.32C313.07,310.59,316.24,311.1,318.83,309.41Z",
    style: {
      fill: "#e4dad9",
      stroke: "#e4dad9",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7,312.8c8-1.14,15.92-2.89,24-3.75,1.42,7.89,3.42,15.8,2.92,23.88a103.58,103.58,0,0,1-1.23,11c-4.65,1.23-9.49,1.62-14.2,2.55-3.55-6.34-7.37-12.77-8.66-20C23.57,321.89,22.32,317.41,21.7,312.8Z",
    style: {
      fill: "#fb986f",
      stroke: "#fb986f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,309.58l5.94.08q.06,3,.1,6-3.44,0-6.87-.07A42.46,42.46,0,0,1,116.07,309.58Z",
    style: {
      fill: "#5989b3",
      stroke: "#5989b3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,312.17c.93,3.38,1.87,6.76,2.7,10.17,5.65-1.37,11.18-3.32,17-4.07-5.15,3.67-11.92,3.41-17.36,6.56.35.68.69,1.36,1,2l.77,1.56c.95,2.37,1.69,4.82,2.48,7.26,6.09,0,12.17,0,18.26-.07l-.32-1.28c6.76,2.74,14.24,1.88,21.32,1.26a32.79,32.79,0,0,1,.85,3.52l.06.49.19,1.83c12.38.57,24.78-.23,37.16.41h1.14l.4-.48c2.58-2.26,3.2-5.54,2.89-8.81l1.71-.19c.69,1.06,1.37,2.15,2,3.25a41.24,41.24,0,0,1,9.15.61,82.72,82.72,0,0,1-8.32.38l-1.88,2.15L171.82,340c-1.87,1.89-3.54,4.71-6.65,4.31-11.88.08-23.77.09-35.66,0-.31,1.06-.62,2.13-.92,3.2-2,1.63-4,3.38-5.9,5.13a30.78,30.78,0,0,1-8.5,1c-19.33-.09-38.67-.2-58,0a43,43,0,0,1-7.17-.64c.26-1.16.52-2.31.77-3.45,1-.67,2.06-1.34,3.1-2a13,13,0,0,0-.83-8l2.35-1.12,1.45-.36q-.6,1.13-1.14,2.28l.12,2c.12,1.66.24,3.32.25,5l-1.22,2.08c22.29-.09,44.59-.05,66.88,0l-.18-2,0-.75,0-1.91v-2.47c0-.47,0-1.42-.06-1.89-4.62,0-9.24,0-13.85-.13,4.87-2,10.43.32,15.13-2.18-5.79-.9-11.61.16-17.41.12-12.55,0-25.08-.68-37.62-1,5-1.41,10.29-.73,15.39-1.7,1.41-.18,2.82-.34,4.24-.5-1.32-2.9-2.67-5.79-4.12-8.62V326c1.33-2.56.44-5.16-.68-7.57C81.6,316.3,81.86,314.23,82,312.17Z",
    style: {
      fill: "#62252e",
      stroke: "#62252e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,313.38c3.62,0,7.24-.09,10.87-.12l1.44,2c-3.94,0-7.88-.08-11.81,0C284.4,314.81,284.15,313.85,284,313.38Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.51,313.28c7.63-.63,15.29-.27,22.94-.38a17.65,17.65,0,0,1,1.16,10.31c-7.08-1.88-14.56-.11-21.8-.89l1.29-1.12c6.54-1.15,13.28.43,19.83-.79-1.74-1-3.77-.67-5.67-.71-5.48.14-11,.05-16.44,0,0-.35,0-1.05,0-1.4,7.49-.11,15-.06,22.47-.06l0-1.3c-7.54-.12-15.09-.06-22.63,0C298.33,315.69,297.93,314.47,297.51,313.28Z",
    style: {
      fill: "#c3bcbd",
      stroke: "#c3bcbd",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.15,314.6c7.05-.33,14.14,0,21.19.23l1.61.87c-6.93.3-13.89.31-20.82.05Z",
    style: {
      fill: "#f9f3f5",
      stroke: "#f9f3f5",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,314.55c1.94.26,3.89.53,5.85.67l3,.06c18.6,0,37.2.06,55.8,0,2.24,0,4.47.08,6.71.19-.85,1.11-1.89,2.25-3.46,2-20.37.06-40.74,0-61.12,0C179.66,317.33,176.28,317.44,175.35,314.55Z",
    style: {
      fill: "#521115",
      stroke: "#521115",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.78,315.35c4.24.26,8.49.22,12.74.34l.28,3.51c-4.36.06-8.72.05-13.07.21C283.74,318.39,283.77,316.37,283.78,315.35Z",
    style: {
      fill: "#7c71a6",
      stroke: "#7c71a6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.18,316.83c3.47-.14,6.95-.16,10.43-.1.06,1.55.11,3.1.17,4.65-3.7,0-7.4,0-11.09-.1C266.86,319.79,267,318.31,267.18,316.83Z",
    style: {
      fill: "#3f667f",
      stroke: "#3f667f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.66,316.93c7.54,0,15.09-.08,22.63,0l0,1.3c-7.49,0-15,0-22.47.06Z",
    style: {
      fill: "snow",
      stroke: "snow",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,318.15c1.49-1.13,2.92,1.54,1.64,2.56C173.56,321.84,172.14,319.15,173.43,318.15Z",
    style: {
      fill: "#754459",
      stroke: "#754459",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.52,318.41l3.29-.2c1,2.87,2.3,6.64-.08,9.19-.8,1.07-2.18,1.31-3.34,1.81C250.41,325.66,250.86,322,249.52,318.41Z",
    style: {
      fill: "#ad4953",
      stroke: "#ad4953",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.48,318.38c1.12,2.41,2,5,.68,7.57A17.65,17.65,0,0,1,81.48,318.38Z",
    style: {
      fill: "#7c515e",
      stroke: "#7c515e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3,320.08l4.49-.76c.37,3.17.59,6.59-1.92,9-.74-2.5-1.25-5.13-2.66-7.35C166.23,320.76,166.27,320.31,166.3,320.08Z",
    style: {
      fill: "#697698",
      stroke: "#697698",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,320.25c16.42-.2,32.84,0,49.26-.21,1.19,0,2.39,0,3.59,0,0,.23-.07.68-.09.91a24.25,24.25,0,0,0,.14,6.91c-9.71-.5-19.43.07-29.15-.14-6.87.16-13.89-.63-20.61,1.22l-1.3-.12a60.82,60.82,0,0,1-2.2-7.73Z",
    style: {
      fill: "#d8d3d6",
      stroke: "#d8d3d6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93,319.3c23.44.56,46.9-.08,70.33.35-4.42,2-9.34,1.22-14,1.3-18.47-.45-37,.42-55.41-.21Z",
    style: {
      fill: "#f5e1e6",
      stroke: "#f5e1e6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,319.65c.1.57.28,1.71.37,2.27-15.47,0-30.94-.32-46.41-.08-7.54.23-15.13-.62-22.64.41,4.17.92,8.44.55,12.67.51,18.82.18,37.64-.13,56.46.07l-.09,1.11c-23.09-.13-46.18.15-69.27,0l-.52-3.2c18.46.63,36.94-.24,55.41.21C238.92,320.87,243.84,321.6,248.26,319.65Z",
    style: {
      fill: "#cec6c9",
      stroke: "#cec6c9",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.51,319.54q6.3.06,12.6-.17c-.13.57-.37,1.72-.5,2.29-4,.14-8,0-12,.09C284.61,321.19,284.54,320.09,284.51,319.54Z",
    style: {
      fill: "#dfd0ee",
      stroke: "#dfd0ee",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.82,319.73c5.48,0,11,.11,16.44,0,1.9,0,3.93-.27,5.67.71-6.55,1.22-13.29-.36-19.83.79l-1.29,1.12c7.24.78,14.72-1,21.8.89l-.56,1.14c-7.53-.2-15.06-.1-22.59-.16C298.61,322.7,298.73,321.21,298.82,319.73Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,323.31c.05-.69.12-1.36.2-2,3.69.08,7.39.07,11.09.1l2.61,0c-.11,3.34.18,6.68.25,10a101.2,101.2,0,0,1-11.94,0l-.79-.25c4,.24,8,.14,12.07.07.11-2,.21-3.95.29-5.92-.89-.74-1.77-1.47-2.66-2.19C273.9,323.23,270.2,323.26,266.49,323.31Z",
    style: {
      fill: "#bbe4ff",
      stroke: "#bbe4ff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66,322.63c3.75-.05,7.51-.17,11.27-.25l-.79,2.13c-3.55.14-7.11.27-10.66.26C66.52,324.24,66.61,323.17,66.66,322.63Z",
    style: {
      fill: "#385775",
      stroke: "#385775",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.58,322.25c7.51-1,15.1-.18,22.64-.41,15.47-.24,30.94.09,46.41.08l.08.91c-18.82-.2-37.64.11-56.46-.07C188,322.8,183.75,323.17,179.58,322.25Z",
    style: {
      fill: "#eae2e5",
      stroke: "#eae2e5",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.91,321.75h.73c4,0,8,.05,12-.09a12.24,12.24,0,0,1-4.75,7.67c-2.7.67-5.5.26-8.22.05Q283.73,325.55,283.91,321.75Z",
    style: {
      fill: "#776ca3",
      stroke: "#776ca3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.38,326.87c6.12-1.57,12.17-3.55,18.45-4.36-1.86,2.31-4.9,2.63-7.57,3.33-3.39.78-6.71,1.85-10.11,2.59Z",
    style: {
      fill: "#fdf2ea",
      stroke: "#fdf2ea",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.83,322.51a120.63,120.63,0,0,0,2.74,11.83l.32,1.28c-6.09.07-12.17.11-18.26.07-.79-2.44-1.53-4.89-2.48-7.26,3.4-.74,6.72-1.81,10.11-2.59C98.93,325.14,102,324.82,103.83,322.51Z",
    style: {
      fill: "#f79970",
      stroke: "#f79970",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,323.77c1.09-.12,2.18-.24,3.27-.34-.81,2.55-3,4.24-4.64,6.25l-2.46-.22a35.38,35.38,0,0,1,3.3-2.55C173.68,325.86,173.86,324.81,174,323.77Z",
    style: {
      fill: "#f3c3ab",
      stroke: "#f3c3ab",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.35,323.94c23.09.15,46.18-.13,69.27,0l.24,1c-23.36.14-46.73.07-70.09.1Z",
    style: {
      fill: "#e9e3e4",
      stroke: "#e9e3e4",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,324.28c2.16-.3,4.33-.58,6.48-1,0,1.81,0,3.62-.05,5.44-2.72-.12-5.44-.17-8.16-.23L255.8,327C255.86,326.34,256,325,256.06,324.28Z",
    style: {
      fill: "#fff2f4",
      stroke: "#fff2f4",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,323.31c3.71-.05,7.41-.08,11.12-.15.89.72,1.77,1.45,2.66,2.19-.08,2-.18,3.95-.29,5.92-4,.07-8.05.17-12.07-.07l-1.61-.51C266.32,328.22,266.34,325.76,266.49,323.31Z",
    style: {
      fill: "#5d97c1",
      stroke: "#5d97c1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.77,325.07c23.36,0,46.73,0,70.09-.1-.48,1.1-1,2.2-1.42,3.3-23.52,0-47-.11-70.56.05C177.52,327.24,178.17,326.17,178.77,325.07Z",
    style: {
      fill: "#d6c4c6",
      stroke: "#d6c4c6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.35,324.62c7.49-.17,15-.2,22.49.15-.27.56-.82,1.69-1.09,2.26-7.42-.94-14.91,0-22.33-.84Z",
    style: {
      fill: "#f9f6f7",
      stroke: "#f9f6f7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.11,326c19.7-.3,39.41.1,59.11-.08a56.61,56.61,0,0,1,6.51.41,19.07,19.07,0,0,1-5.51.74c-20.06-.17-40.11-.08-60.17-.17Z",
    style: {
      fill: "#f2e6e6",
      stroke: "#f2e6e6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.81,329.78c.93-1.16,1.8-2.35,2.61-3.59,7.42.79,14.91-.1,22.33.84q-.78,1.58-1.53,3.18C310.42,330,302.56,330.81,294.81,329.78Z",
    style: {
      fill: "#f5ecf2",
      stroke: "#f5ecf2",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.16,326.31c1.45,2.83,2.8,5.72,4.12,8.62-1.42.16-2.83.32-4.24.5C82,332.39,82,329.34,82.16,326.31Z",
    style: {
      fill: "#f49b78",
      stroke: "#f49b78",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,329c6.72-1.85,13.74-1.06,20.61-1.22,9.72.21,19.44-.36,29.15.14l-.08,1.19C149.71,329.14,133.15,329.29,116.59,329Z",
    style: {
      fill: "#e9dce8",
      stroke: "#e9dce8",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,336.52a60,60,0,0,1,10.35-5.64c.12,1.29.24,2.58.38,3.88A42.53,42.53,0,0,1,52,336.52Z",
    style: {
      fill: "#eda28d",
      stroke: "#eda28d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.16,332.91c4.22-1.29,8.69-.35,13-.53,12.26-.21,24.53.33,36.78-.14a39.63,39.63,0,0,0,.2,9.61c-12.38-.64-24.78.16-37.16-.41,11.95-1,24,.51,35.93-.8,0-.22-.11-.65-.15-.86-12-.54-24-.11-36-.17l-.06-.49c12.15.13,24.31.12,36.47.07,0-1.95,0-3.89,0-5.83-10.67,0-21.34.1-32,0C127.52,333.24,121.84,332.22,116.16,332.91Z",
    style: {
      fill: "#9d939f",
      stroke: "#9d939f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.09,332l1.49.58c.31,3.27-.31,6.55-2.89,8.81C167,338.13,166.69,334.62,169.09,332Z",
    style: {
      fill: "#ad8365",
      stroke: "#ad8365",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.29,332.37c29.43-.43,58.91-.05,88.36-.2q0,4.6-.08,9.21c-29.65-.1-59.31.12-89-.1l1.65-2.52,1.88-2.15a82.72,82.72,0,0,0,8.32-.38,41.24,41.24,0,0,0-9.15-.61C173.66,334.52,173,333.43,172.29,332.37Z",
    style: {
      fill: "#f9f6f7",
      stroke: "#f9f6f7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.65,332.17c1.07.38,2.12.83,3.17,1.29,0,2.37-.13,4.74-.22,7.11,8.91,0,18.52.59,26.16,5.67,1.38,0,2.75-.07,4.14-.08-1.09,2.35-3.37,2.25-5.56,1.7-2.71-2.64-6.56-3.16-10.08-4a60.14,60.14,0,0,0-14.47-1.43c-.83.59-1.65,1.2-2.47,1.8-1.62.26-3.23.56-4.84.85h-1.4l-.15,0c-5.27-2.38-11.1-1.32-16.68-1.44-20.45-.07-40.87.33-61.31-.21l-2,1.81c-1.06-.93-2.13-1.85-3.17-2.79l-.2-1.15c29.65.22,59.31,0,89,.1Q260.67,336.78,260.65,332.17Z",
    style: {
      fill: "#331d2c",
      stroke: "#331d2c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8,334.89c1.09-.72,2.21-1.37,3.36-2,5.68-.69,11.36.33,17.05.41,10.67.14,21.34,0,32,0,0,1.94,0,3.88,0,5.83-12.16.05-24.32.06-36.47-.07a32.79,32.79,0,0,0-.85-3.52C123,334,117.83,335.21,112.8,334.89Z",
    style: {
      fill: "#dbd4d8",
      stroke: "#dbd4d8",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,332.15a36.86,36.86,0,0,1,7.64.5l1.47.66a65.78,65.78,0,0,0,8.88.1,69.27,69.27,0,0,0-12.9,5.18,72.26,72.26,0,0,0-8.72-4.23C280.74,333.6,282,332.88,283.17,332.15Z",
    style: {
      fill: "#f79973",
      stroke: "#f79973",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.82,333.46l.27.05c4.47.76,9.08.78,13.44,2.18,5.05,1.48,10.18,3.91,12.83,8.72l-.6,1.83c-7.64-5.08-17.25-5.68-26.16-5.67C263.69,338.2,263.78,335.83,263.82,333.46Z",
    style: {
      fill: "#fdf8f7",
      stroke: "#fdf8f7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,335.85c4-.62,8.11-.14,12.17-.32,0,.45.07,1.34.09,1.79-3.88-.12-7.78.11-11.66-.12Z",
    style: {
      fill: "#78757b",
      stroke: "#78757b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.59,335.57c4.63.09,9.27,0,13.9.18l-1,1.44c-4.28.3-8.57,0-12.86,0Z",
    style: {
      fill: "#7e7b83",
      stroke: "#7e7b83",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,336.46a39,39,0,0,1,8.57,0A11.21,11.21,0,0,1,251,336.46Z",
    style: {
      fill: "#39213a",
      stroke: "#39213a",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.51,339.61a49,49,0,0,1,12.71-4.26c1.87,2,3.82,4,4.73,6.68a54.3,54.3,0,0,0-12.76,1.84c-1,.28-1.94.57-2.9.87-.37-1-.74-2-1.09-3C291,341.18,290.68,340.14,290.51,339.61Z",
    style: {
      fill: "#fdf9fa",
      stroke: "#fdf9fa",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.75,335.27c8.46.79,17,.29,25.44.48,27.08-.2,54.16.23,81.23-.18l.13.3a51.82,51.82,0,0,0-2.89,4.86l-.8,0c-6.84-.94-13.74-.62-20.61-.73-26.24.2-52.49-.18-78.73.16l-.16-.72A52.7,52.7,0,0,0,305.75,335.27Z",
    style: {
      fill: "#d9d2d8",
      stroke: "#d9d2d8",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.86,338c3.21-.26,6.42-.38,9.62-.7l1.17-.12c12.54.29,25.07.95,37.62,1,5.8,0,11.62-1,17.41-.12-4.7,2.5-10.26.18-15.13,2.18-17.27.32-34.56.23-51.83.07Q55.26,339.07,55.86,338Z",
    style: {
      fill: "#954450",
      stroke: "#954450",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.66,340.73a51.82,51.82,0,0,1,2.89-4.86l.71,1.7c-.26.75-.55,1.5-.86,2.24,7.51,4.44,15.29,8.47,22.67,13.13a17.19,17.19,0,0,1-.07,8.4l-2.4.2c-.11,19.53,0,39,0,58.58q-210.33,0-420.66,0c.11-19.59-.29-39.19.21-58.77A69.25,69.25,0,0,1,30,361.22c0,1.59,0,3.19,0,4.8-.69-1.17-1.38-2.33-2-3.51l-.36-1.12c-4.58.06-9.16.06-13.74.07.12,18.88,0,37.76,0,56.63q7.07.17,14.11-.2h1.95c21.09.52,42.2.09,63.31.23,38.81,0,77.62-.06,116.43.07,0-2.4,0-4.79.07-7.17l.31,0c.17,2.43.29,4.86.4,7.3l1.34-.05c3.73-.14,7.46-.08,11.19-.3l1.85-.11a77.2,77.2,0,0,0,11.68.11l1.54-.1c23.74.63,47.5.11,71.25.28,35.11,0,70.23-.07,105.35,0h2.17c4.41,0,8.83-.09,13.25.07.75-5.09.43-10.24.45-15.36,0-13.81,0-27.62,0-41.43,1.07-.16,2.14-.36,3.22-.56,0-.4-.09-1.22-.13-1.63-.12-1.58-.23-3.16-.33-4.73q-211.17,0-422.35,0c-.09,1.52-.19,3-.3,4.56a11.54,11.54,0,0,1-.87-4.33,34,34,0,0,1,5.83-2.23c11.15.21,22.34-.52,33.45.34a43,43,0,0,0,7.17.64c19.33-.16,38.67,0,58,0a30.78,30.78,0,0,0,8.5-1c59.9-.21,119.81,0,179.72-.11.47-1.37.95-2.73,1.44-4.09l-6,.13c-.32.52-.95,1.55-1.26,2.07-2.81.37-5.66.95-8.48.49-2.37-.72-4.43-2.34-6.93-2.59-18.65-1.24-37.35-1-56-1-17.52,0-35-.06-52.54,0-.28-1.69-.56-3.39-.85-5.06,1,.94,2.11,1.86,3.17,2.79,24.41.2,48.81-.09,73.22.12,2.25,0,4.49-.16,6.73-.28l.15,0h1.4c10,1.24,20.34.05,30.25,2.49,1.47.55,2.86,1.48,4.47,1.59a31.27,31.27,0,0,0,5.09-2,76.23,76.23,0,0,1,10.68-.7c0-.58.1-1.74.13-2.32a68.61,68.61,0,0,0-11,1.42l-.94-1.7A54.3,54.3,0,0,1,308,342c.46-.88.93-1.75,1.41-2.62l.16.72.11.77.09,1,0,.93-.09,1.08-.07.57c-.12.62-.34,1.86-.45,2.48l-1.41,1c-.64.85-1.22,1.73-1.81,2.61q53.73.15,107.46,0c-.48-.62-1-1.21-1.42-1.82L410.7,348c-.33-1.35-.65-2.68-.9-4l-.12-1.1,0-.92Z",
    style: {
      fill: "#4b1e21",
      stroke: "#4b1e21",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54,340.12a22.61,22.61,0,0,1,4.19-2.2,39.28,39.28,0,0,1-.09,7.59c-.41,2-2.44,2.61-4,3.39C122.55,346,122.56,343.05,122.54,340.12Z",
    style: {
      fill: "#b04b53",
      stroke: "#b04b53",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82,340l1.44-1.24-1.65,2.52.2,1.15c.29,1.67.57,3.37.85,5.06,17.51-.08,35,0,52.54,0,18.68,0,37.38-.21,56,1,2.5.25,4.56,1.87,6.93,2.59,2.82.46,5.67-.12,8.48-.49.31-.52.94-1.55,1.26-2.07l6-.13c-.49,1.36-1,2.72-1.44,4.09-59.91.15-119.82-.1-179.72.11,1.94-1.75,3.86-3.5,5.9-5.13.3-1.07.61-2.14.92-3.2,11.89.13,23.78.12,35.66,0C168.28,344.71,170,341.89,171.82,340Z",
    style: {
      fill: "#f89976",
      stroke: "#f89976",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.05,339.53l2-.1a13,13,0,0,1,.83,8c-1,.65-2.07,1.32-3.1,2-.25,1.14-.51,2.29-.77,3.45-11.11-.86-22.3-.13-33.45-.34H14.06c4.92-3.16,10.18-5.73,15.3-8.54q1.32,2.28,2.63,4.57c5.62-.91,11.45-1.24,16.86-3A25.29,25.29,0,0,0,50.05,339.53Z",
    style: {
      fill: "#f79a7b",
      stroke: "#f79a7b",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72,340.23c17.27.16,34.56.25,51.83-.07,4.61.13,9.23.1,13.85.13,0,.47,0,1.42.06,1.89-21.87.11-43.75-.21-65.62.1Z",
    style: {
      fill: "#f9f6f7",
      stroke: "#f9f6f7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.8,339.61c12,.06,24-.37,36,.17,0,.21.11.64.15.86-11.89,1.31-24-.24-35.93.8Z",
    style: {
      fill: "#ece8f5",
      stroke: "#ece8f5",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.52,340.13c26.24-.34,52.49,0,78.73-.16,6.87.11,13.77-.21,20.61.73-33.07.47-66.15.07-99.23.2Z",
    style: {
      fill: "#bcb8b7",
      stroke: "#bcb8b7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.63,340.9c33.08-.13,66.16.27,99.23-.2l.8,0,0,1.23c-33.3-.14-66.61,0-99.92-.06Z",
    style: {
      fill: "#fffdfd",
      stroke: "#fffdfd",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.84,342.28c21.87-.31,43.75,0,65.62-.1v.49c-21.59,0-43.19-.16-64.78.06l-.08,1.91c8.51-.72,17-.36,25.57-.4q19.65,0,39.3,0v.43c-19.09-.22-38.19,0-57.28-.1-2.31.31-5.51-.52-6.79,2.08,21.37.11,42.75.27,64.11-.07l0,.75q-32.73-.31-65.48,0C55.08,345.6,55,343.94,54.84,342.28Z",
    style: {
      fill: "#7869a3",
      stroke: "#7869a3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.2,341.71c.35,1,.72,2,1.09,3,1-.3,1.93-.59,2.9-.87l.94,1.7-1.65,1.69,1.81-.09a31.27,31.27,0,0,1-5.09,2c-1.61-.11-3-1-4.47-1.59l1.61.28c2.19.55,4.47.65,5.56-1.7-1.39,0-2.76.11-4.14.08l.6-1.83Z",
    style: {
      fill: "#785f69",
      stroke: "#785f69",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.72,341.9c33.31,0,66.62-.08,99.92.06l0,.92q-50,0-99.94-.05Z",
    style: {
      fill: "#bcb5b6",
      stroke: "#bcb5b6",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.69,342.73c21.59-.22,43.19-.09,64.78-.06v1.55q-19.65,0-39.3,0c-8.52,0-17.06-.32-25.57.4Z",
    style: {
      fill: "#f2ecf0",
      stroke: "#f2ecf0",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,344.24c.82-.6,1.64-1.21,2.47-1.8a60.14,60.14,0,0,1,14.47,1.43c3.52.83,7.37,1.35,10.08,4l-1.61-.28c-9.91-2.44-20.21-1.25-30.25-2.49C258.09,344.8,259.7,344.5,261.32,344.24Z",
    style: {
      fill: "#fff9ff",
      stroke: "#fff9ff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.74,342.83q50,.1,99.94.05l.12,1.1c-27.52.41-55-.19-82.56.11-5.87.11-11.73.11-17.59-.18Z",
    style: {
      fill: "#f2e9eb",
      stroke: "#f2e9eb",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.25,342c4.14,1.56,7.77,4.12,11.68,6.16,2.31,1.24,4.73,2.41,6.58,4.34-4.32.17-8.64,0-13,0-.3-.94-.61-1.87-.9-2.79A9.32,9.32,0,0,1,411.25,342Z",
    style: {
      fill: "#f59975",
      stroke: "#f59975",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,345.22l2-1.81c20.44.54,40.86.14,61.31.21,5.58.12,11.41-.94,16.68,1.44-2.24.12-4.48.27-6.73.28C223.79,345.13,199.39,345.42,175,345.22Z",
    style: {
      fill: "#7869a3",
      stroke: "#7869a3",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,345.57a68.61,68.61,0,0,1,11-1.42c0,.58-.1,1.74-.13,2.32a76.23,76.23,0,0,0-10.68.7l-1.81.09Z",
    style: {
      fill: "#ffe7ef",
      stroke: "#ffe7ef",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.65,343.91c5.86.29,11.72.29,17.59.18,27.52-.3,55,.3,82.56-.11.25,1.35.57,2.68.9,4-34.33-.25-68.66-.05-103-.09l1.41-1c33.43-.28,66.88.24,100.31-.26l-1-1.81q-37.62-.19-75.24-.18c-7.87-.09-15.75.81-23.58-.23Z",
    style: {
      fill: "#bfbabd",
      stroke: "#bfbabd",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.42,346.63c1.28-2.6,4.48-1.77,6.79-2.08,19.09.1,38.19-.12,57.28.1l0,1.91C99.17,346.9,77.79,346.74,56.42,346.63Z",
    style: {
      fill: "#ece5e7",
      stroke: "#ece5e7",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.13,347c.11-.62.33-1.86.45-2.48,7.83,1,15.71.14,23.58.23q37.62,0,75.24.18l1,1.81C376,347.2,342.56,346.68,309.13,347Z",
    style: {
      fill: "#e4dee1",
      stroke: "#e4dee1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.87,349.35l1.22-2.08q32.73-.25,65.48,0l.18,2C98.46,349.3,76.16,349.26,53.87,349.35Z",
    style: {
      fill: "#f7dce1",
      stroke: "#f7dce1",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.91,350.53c.59-.88,1.17-1.76,1.81-2.61l.21,1.48c30.09-.08,60.18.05,90.27,0,4.58-.09,9.25.57,13.75-.63.45.61.94,1.2,1.42,1.82Q359.64,350.63,305.91,350.53Z",
    style: {
      fill: "#a49fad",
      stroke: "#a49fad",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.72,347.92c34.32,0,68.65-.16,103,.09l1.25.72c-4.5,1.2-9.17.54-13.75.63-30.09.09-60.18,0-90.27,0Z",
    style: {
      fill: "#fdf9ff",
      stroke: "#fdf9ff",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.91,354.54q211.17.15,422.35,0c.1,1.57.21,3.15.33,4.73-51.45.32-102.91.05-154.37.15h-229c-12.74.06-25.49-.18-38.22.13l-1.38-.43C10.72,357.57,10.82,356.06,10.91,354.54Z",
    style: {
      fill: "#f49b78",
      stroke: "#f49b78",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.59,359.25c0,.41.1,1.23.13,1.63-1.08.2-2.15.4-3.22.56-4.6.09-9.19-.09-13.78,0,.08,18.91-.08,37.82.06,56.73h-2.17c0-2.5,0-5,0-7.51-58.66,0-117.32.14-176-.07-.18,2.43-.34,4.86-.65,7.28l-1.54.1c-.21-8.1.06-16.19-.12-24.29-2.81,3.87-6.55,7.11-11.42,7.92,0,5.42.17,10.84-.14,16.26l-1.85.11q.09-8.28,0-16.54c-4.88-.72-8.37-4.2-11.31-7.86,0,8.23,0,16.47.1,24.7l-1.34.05c-.11-2.44-.23-4.87-.4-7.3l-.16-2.4c-.38-13.46,0-26.93-.13-40.39v-2.14c0-1.54,0-3.09.05-4.63-44.85-.06-89.71,0-134.57,0-15.08-.14-30.17.26-45.24-.21a69.25,69.25,0,0,0-17.85.12L12,359.53c12.73-.31,25.48-.07,38.22-.13h229C330.68,359.3,382.14,359.57,433.59,359.25Z",
    style: {
      fill: "#571206",
      stroke: "#571206",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85,361.51c3.66,0,7.33,0,11-.06,0,4.75,0,9.51,0,14.28-5,.31-8.89,3.81-10.94,8.21C211.69,376.46,211.85,369,211.85,361.51Z",
    style: {
      fill: "#f3c3ab",
      stroke: "#f3c3ab",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.84,361.46c4.58,0,9.16,0,13.74-.07l.36,1.12c0,18.46-.07,36.92,0,55.38q-7.05.38-14.11.2C13.84,399.22,14,380.34,13.84,361.46Z",
    style: {
      fill: "#fa976e",
      stroke: "#fa976e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,361.22c15.07.47,30.16.07,45.24.21,44.86,0,89.72-.05,134.57,0,0,1.54,0,3.09-.05,4.63Q119.86,366,30,366C30,364.41,30,362.81,30,361.22Z",
    style: {
      fill: "#f59772",
      stroke: "#f59772",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.93,361.45q5.79,0,11.58,0c-.4,7.51.44,15.07-.42,22.55-2.14-4.19-5.72-7.6-10.58-8.13C224.24,371.33,225.31,366.21,224.93,361.45Z",
    style: {
      fill: "#fa996f",
      stroke: "#fa996f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,361.48c58.8-.16,117.6,0,176.4-.09,0,1.6,0,3.21-.05,4.83-58.69,0-117.38-.05-176.06.06C238.53,364.67,238.43,363.07,238.34,361.48Z",
    style: {
      fill: "#f59672",
      stroke: "#f59672",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.72,361.43c4.59-.08,9.18.1,13.78,0,0,13.81,0,27.62,0,41.43,0,5.12.3,10.27-.45,15.36-4.42-.16-8.84-.1-13.25-.07C416.64,399.25,416.8,380.34,416.72,361.43Z",
    style: {
      fill: "#fa986f",
      stroke: "#fa986f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.94,362.51c.66,1.18,1.35,2.34,2,3.51q89.87.09,179.74.05v2.14q-89.77,0-179.57,0c0,13.47-.19,26.94,0,40.41q89.84.11,179.68,0L210,411l-.31,0q-89.67.06-179.34,0c-.16,2.29-.32,4.57-.47,6.86H27.94C27.87,399.43,27.93,381,27.94,362.51Z",
    style: {
      fill: "#772e1d",
      stroke: "#772e1d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.89,363.82c2.26-2.68,8.94-2.54,8.91,1.94a61.56,61.56,0,0,1-.09,8.26c-2.93,1.66-5.91,3.25-9,4.62C212.63,373.71,212.2,368.72,212.89,363.82Z",
    style: {
      fill: "#fb976d",
      stroke: "#fb976d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.15,368.2q89.79,0,179.57,0c.15,13.46-.25,26.93.13,40.39q-89.83.16-179.68,0C30,395.14,30.14,381.67,30.15,368.2Z",
    style: {
      fill: "#fb986f",
      stroke: "#fb986f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,368.13c58.79.1,117.59-.15,176.38.12q-.17,20.13,0,40.27c-17.86.49-35.74,0-53.6.21-40.95,0-81.88,0-122.82-.06C238.22,395.16,238.36,381.64,238.42,368.13Z",
    style: {
      fill: "#fb986f",
      stroke: "#fb986f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.62,378.43c4.55-1.14,10.13.1,12.48,4.52,3.84,5.51.63,14.07-5.78,15.88-6.32,2.28-14.23-3.09-13.81-9.95A10,10,0,0,1,220.62,378.43Z",
    style: {
      fill: "#fa986f",
      stroke: "#fa986f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.66,380.46c4.29-2.46,10.44-.39,12,4.41,2.89,5.8-3.17,13-9.4,11.55C110.65,395.59,108.84,383.73,115.66,380.46Z",
    style: {
      fill: "#550e02",
      stroke: "#550e02",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.51,380.37c5.3-2.84,12.57,1.37,12.24,7.49.51,5.86-6.19,10.5-11.56,8.12C316.64,393.67,316.24,383.25,322.51,380.37Z",
    style: {
      fill: "#531103",
      stroke: "#531103",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4,387.88c-.56-3.26,2.41-5,4.57-6.73,3,.27,6.8.81,7.82,4.13,2.08,3.91-1.17,9.34-5.62,9.21C116.57,395,112.89,391.57,113.4,387.88Z",
    style: {
      fill: "#bb694f",
      stroke: "#bb694f",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.42,382.15c3.92-2.55,9.75,1.19,9.4,5.77.53,5.28-6.92,8.9-10.63,5C318.71,390.1,319.51,384.16,323.42,382.15Z",
    style: {
      fill: "#bb6c4e",
      stroke: "#bb6c4e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.65,393.55c2.94,3.66,6.43,7.14,11.31,7.86q.07,8.26,0,16.54c-3.73.22-7.46.16-11.19.3C211.62,410,211.65,401.78,211.65,393.55Z",
    style: {
      fill: "#dc917e",
      stroke: "#dc917e",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.93,401.58c4.87-.81,8.61-4.05,11.42-7.92.18,8.1-.09,16.19.12,24.29a77.2,77.2,0,0,1-11.68-.11C225.1,412.42,224.89,407,224.93,401.58Z",
    style: {
      fill: "#fa9772",
      stroke: "#fa9772",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.42,399.17c2.85,1,6.21,2.09,8,4.66a56.4,56.4,0,0,1,0,11.1c-1.25,3.16-5.39,1.73-7.84,1C213.72,410.35,211.63,404.57,213.42,399.17Z",
    style: {
      fill: "#fc976d",
      stroke: "#fc976d",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.36,411q89.67,0,179.34,0c-.09,2.38-.07,4.77-.07,7.17-38.81-.13-77.62,0-116.43-.07-21.11-.14-42.22.29-63.31-.23C30,415.6,30.2,413.32,30.36,411Z",
    style: {
      fill: "#f8956c",
      stroke: "#f8956c",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,417.85c.31-2.42.47-4.85.65-7.28,58.66.21,117.32.06,176,.07,0,2.5,0,5,0,7.51-35.12-.09-70.24,0-105.35,0C285.51,418,261.75,418.48,238,417.85Z",
    style: {
      fill: "#f8956c",
      stroke: "#f8956c",
      strokeWidth: "0.25px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookshelf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bookshelf.39db355daeda8bba6621894966f2fe1e.svg";